/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 124);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// registry of all custom events used in the app. Not ideal abstraction but good
// for sanity without going and reinventing interfaces.

var customEventNames = [
  'dataCurrentTrackInfo',
  'dataNowPlayingInfo',
  'dataShowInfo',
  'dataBroadcastInfo',
  'dataHtmlPage',

  'navigationRequestStarted',
  'navigationRequestProgress',
  'navigationRequestEnded',

  'uiMediaStateChange',
  'uiMainMenuToggled',
  'uiScrollSnap',
  'uiSliderValueChanged',
  'uiUpdateSliderValue',
  'uiDidSearch',
  'uiModalDismiss',
  'uiWantsDonation',

  // Audio manager events (controls what's going to play)
  'audioWantsPlayback',
  'audioWantsSkip',
  'audioWantsPause',
  'audioWantsStop',
  'audioWantsSetVolume',
  'audioNothingToPlay',
  'audioCueSource',
  'audioClearSource',
  'audioCued',
  'audioFormatNotSupported',

  // Audio source (MP3 stream or archive) events
  'audioSourceLoading',
  'audioSourcePlaying',
  'audioSourcePaused',
  'audioSourceResumed',
  'audioSourceSeekOutOfRange',
  'audioSourceStalled',
  'audioSourceEnded',
  'audioSourceTimeUpdate',
  'audioSourceMetadataUpdate',
  'audioSourceVolumeChanged',

  'streamPlay',

  'themeChange',
  'themeWasChanged',

  'donationEnded',
  'donationStarted'
];

var eventRegistry = {};
customEventNames.forEach(function (evName) {
  eventRegistry[evName] = evName;
});

module.exports = eventRegistry;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/* A builder for creating UI Components with className states and discoverability */

function ComponentObjectHelper(component) {
  this.component = component;
}

ComponentObjectHelper.prototype.defineAttributeProperty = function (propName, attrName, validateFunc, afterSetFunc) {
  const element = this.component.element;
  var shadowValue = null;
  var domIsSetting = false;

  Object.defineProperty(this.component, propName, {
    get: function getAttributeProperty() {
      if (shadowValue === null) {
        shadowValue = element.getAttribute(attrName);
      }
      return shadowValue;
    },
    set: function setAttributeProperty(newValue) {
      const finalValue = (typeof validateFunc === 'function') ? validateFunc(newValue) : newValue;

      // Only update if changing
      if (finalValue === shadowValue) { return; }

      shadowValue = finalValue;

      if (!domIsSetting) {
        domIsSetting = true;
        requestAnimationFrame(function () {
          element.setAttribute(attrName, shadowValue);
          domIsSetting = false;
        });
      }

      if (typeof afterSetFunc === 'function') {
        afterSetFunc(shadowValue);
      }
    }
  });
};

ComponentObjectHelper.prototype.defineClassState = function (propName, className, validateFunc, afterSetFunc) {
  const element = this.component.element;
  var shadowValue = null;
  var domIsSetting = false;

  Object.defineProperty(this.component, propName, {
    get: function getState() {
      if (shadowValue === null) {
        shadowValue = element.classList.contains(className);
      }
      return shadowValue;
    },
    set: function setState(truth) {
      const bool = (validateFunc && typeof validateFunc === 'function') ? !!validateFunc(truth) : !!truth;

      if (shadowValue === bool) { return; }

      shadowValue = bool;

      if (!domIsSetting) {
        domIsSetting = true;
        requestAnimationFrame(function () {
          element.classList.toggle(className, shadowValue);
          domIsSetting = false;
        });
      }

      if (typeof afterSetFunc === 'function') {
        afterSetFunc(shadowValue);
      }
    }
  });
};

function forgeUiComponent(className, states, constructFn) {
  if (typeof className !== 'string') {
    throw new TypeError('Component requires a root className');
  }

  constructFn = constructFn || function () {};
  states = states || {};

  if (typeof constructFn !== 'function') {
    throw new TypeError('Component constructor must be a function');
  }

  if (typeof states !== 'object') {
    throw new TypeError('Component states must be an object');
  }

  // Create a constructor for the component we're defining
  function UiComponent(rootElement, options) {
    var self = this;

    if (!rootElement || rootElement.nodeType !== Node.ELEMENT_NODE) {
      throw new TypeError('Component requires an HTMLElement root');
    }

    options = options || {};

    if (typeof options !== 'object') {
      throw new TypeError('Component options must be an object');
    }

    const initAttribute = UiComponent.initAttribute();
    if (rootElement.getAttribute(initAttribute) !== null) {
      throw new Error('Component already initialized');
    } else {
      rootElement.setAttribute(initAttribute, +new Date());
    }

    const componentBuilder = new ComponentObjectHelper(this);

    Object.defineProperty(this, 'element', {
      get: function getRootElement() { return rootElement; }
    });

    Object.defineProperty(this, 'options', {
      get: function getOptions() { return options; }
    });

    Object.keys(states).forEach(function (stateProp) {
      componentBuilder.defineClassState(stateProp, states[stateProp]);
    });

    constructFn.apply(self, [rootElement, options, componentBuilder]);
  }

  UiComponent.prototype.queryProperty = function queryProperty(propName, returnUndefinedIfAbsent) {
    const selector = ['.', className, '-', propName].join('');
    const element = this.element.querySelector(selector);
    if (element) {
      return element;
    } else if (returnUndefinedIfAbsent) {
      return undefined;
    } else {
      return this.element.ownerDocument.createElement('ui-component-property');
    }
  };

  UiComponent.prototype.queryPropertyAll = function queryProperty(propName) {
    const selector = ['.', className, '-', propName].join('');
    return this.element.querySelectorAll(selector);
  };

  /**
   *
   * @param {String} name The event name
   * @param {Object} detail The CustomEvent detail payload
   * @param {String|Event|HTMLElement} sourceProperty The source of the event (default: component root element)
   * @param {Boolean} bubbles Whether the event bubbles (default: true)
   */
  UiComponent.prototype.dispatchEvent = function dispatchComponentEvent(name, detail, sourceProperty, bubbles) {
    var sourceElement;
    const eventData = {
      detail: detail,
      bubbles: bubbles === undefined ? true : bubbles
    };
    if (!sourceProperty) {
      sourceElement = this.element;
    } else if (sourceProperty instanceof Event) {
      sourceElement = sourceProperty.target;
    } else if (sourceProperty instanceof HTMLElement) {
      sourceElement = sourceProperty;
    } else {
      sourceElement = this.queryProperty(sourceProperty);
    }
    if (!sourceElement) {
      return;
    }
    sourceElement.dispatchEvent(new CustomEvent(name, eventData));
  };

  UiComponent.initAttribute = function initAttribute() {
    return ['data', 'component', className.toLowerCase(), 'initialized'].join('-');
  };

  UiComponent.discover = function discoverComponent(rootElement, options) {
    var components = [];
    var errors = [];

    rootElement = rootElement || document.body;
    options = options || {};

    if (!rootElement || rootElement.nodeType !== Node.ELEMENT_NODE) {
      throw new TypeError('Components can only be discovered inside of DOM Elements');
    }

    if (typeof options !== 'object') {
      throw new TypeError('Component options must be an object');
    }

    if (rootElement.classList.contains(className)) {
      try {
        components += new UiComponent(rootElement, options);
      } catch (e) {
        errors += e;
      }
    } else {
      Array.prototype.forEach.call(rootElement.getElementsByClassName(className), function (discoveredElement) {
        try {
          components += new UiComponent(discoveredElement, options);
        } catch (e) {
          errors += e;
        }
      });
    }

    return {
      components: components,
      errors: errors
    };
  };

  return UiComponent;
}

module.exports = forgeUiComponent;


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async__ = __webpack_require__(102);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(28);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is__ = __webpack_require__(9);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(29);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__logger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__memo__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc__ = __webpack_require__(12);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__object__ = __webpack_require__(103);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__path__ = __webpack_require__(104);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__promisebuffer__ = __webpack_require__(106);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__promisebuffer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__string__ = __webpack_require__(31);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__supports__ = __webpack_require__(107);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__syncpromise__ = __webpack_require__(32);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_11__syncpromise__["a"]; });












//# sourceMappingURL=index.js.map

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* harmony export (immutable) */ __webpack_exports__["d"] = __read;
/* harmony export (immutable) */ __webpack_exports__["c"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__ = __webpack_require__(98);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(8);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(89);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_2__api__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseclient__ = __webpack_require__(91);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_3__baseclient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__basebackend__ = __webpack_require__(90);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_4__basebackend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dsn__ = __webpack_require__(17);
/* unused harmony reexport Dsn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sdk__ = __webpack_require__(96);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_6__sdk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transports_noop__ = __webpack_require__(25);
/* unused harmony reexport NoopTransport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__integrations__ = __webpack_require__(95);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_8__integrations__; });










//# sourceMappingURL=index.js.map

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Derived from https://github.com/bendrucker/document-ready

module.exports = function ready(callback) {
  var state = document.readyState;
  if (state === 'complete' || state === 'interactive') {
    return setTimeout(callback, 0);
  }

  document.addEventListener('DOMContentLoaded', function onLoad() {
    callback();
  });
};


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loglevel__ = __webpack_require__(99);
/* unused harmony reexport LogLevel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__severity__ = __webpack_require__(100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__severity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__status__ = __webpack_require__(101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__status__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 7 */
/***/ (function(module, exports) {

function request(url, options, callbacks) {
  var xhr;
  var success = callbacks.success || function () {};
  var failure = callbacks.failure || function () {};
  var abort = callbacks.abort || callbacks.failure || function () {};
  var progress = callbacks.progress || function () {};

  if (!options.method) {
    failure();
    return false;
  }

  if (!window.XMLHttpRequest) {
    failure();
    return false;
  }

  xhr = new window.XMLHttpRequest();
  xhr.withCredentials = !!options.withCredentials;

  xhr.addEventListener('progress', function (e) {
    if (e.lengthComputable) {
      progress(e.loaded / e.total, xhr);
    } else {
      progress(-1, xhr);
    }
  });

  xhr.addEventListener('error', function (e) {
    failure(e, xhr);
  });
  xhr.addEventListener('abort', function (e) {
    abort(e, xhr);
  });
  xhr.addEventListener('load', function () {
    success(xhr.response, xhr);
  });

  xhr.open(options.method, url, true);

  if (options.headers) {
    Object.keys(options.headers).forEach(function (k) {
      xhr.setRequestHeader(k, options.headers[k]);
    });
  }

  // TODO: Make this explicit getHtml/getJson methods I think
  xhr.responseType = options.responseType || 'document';
  xhr.send();
  return xhr;
}

function get(url, options, callbacks) {
  var fullOptions = options;
  fullOptions.method = 'GET';
  return request(url, fullOptions, callbacks);
}

function head(url, options, callbacks) {
  var fullOptions = options;
  fullOptions.method = 'HEAD';
  return request(url, fullOptions, callbacks);
}

module.exports = {
  request: request,
  get: get,
  head: head
};


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scope__ = __webpack_require__(26);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__scope__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__scope__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hub__ = __webpack_require__(97);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__hub__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__hub__["b"]; });
/* unused harmony reexport getMainCarrier */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__hub__["c"]; });
/* unused harmony reexport makeMain */
/* unused harmony reexport setHubOnCarrier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__span__ = __webpack_require__(27);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__span__["a"]; });
/* unused harmony reexport TRACEPARENT_REGEXP */



//# sourceMappingURL=index.js.map

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isError;
/* harmony export (immutable) */ __webpack_exports__["i"] = isErrorEvent;
/* harmony export (immutable) */ __webpack_exports__["j"] = isDOMError;
/* harmony export (immutable) */ __webpack_exports__["k"] = isDOMException;
/* harmony export (immutable) */ __webpack_exports__["h"] = isString;
/* harmony export (immutable) */ __webpack_exports__["f"] = isPrimitive;
/* harmony export (immutable) */ __webpack_exports__["l"] = isPlainObject;
/* harmony export (immutable) */ __webpack_exports__["d"] = isEvent;
/* harmony export (immutable) */ __webpack_exports__["e"] = isElement;
/* harmony export (immutable) */ __webpack_exports__["b"] = isRegExp;
/* harmony export (immutable) */ __webpack_exports__["a"] = isThenable;
/* harmony export (immutable) */ __webpack_exports__["g"] = isSyntheticEvent;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return wat instanceof Error;
    }
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMError]';
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMException]';
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return Object.prototype.toString.call(wat) === '[object String]';
}
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === '[object Object]';
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    // tslint:disable-next-line:strict-type-predicates
    return typeof Event !== 'undefined' && wat instanceof Event;
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    // tslint:disable-next-line:strict-type-predicates
    return typeof Element !== 'undefined' && wat instanceof Element;
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === '[object RegExp]';
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // tslint:disable:no-unsafe-any
    return Boolean(wat && wat.then && typeof wat.then === 'function');
    // tslint:enable:no-unsafe-any
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    // tslint:disable-next-line:no-unsafe-any
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
//# sourceMappingURL=is.js.map

/***/ }),
/* 10 */
/***/ (function(module, exports) {

/** Verify required functions for the app are available */
function checkCompat() {
  const testElement = document.createElement('DIV');
  const requiredFeatures = [
    document.dispatchEvent,
    testElement.classList,
    testElement.closest,
    window.Audio,
    window.CustomEvent,
    window.requestAnimationFrame
  ];
  const j = requiredFeatures.length;
  var i = 0;

  for (; i < j; i += 1) {
    if (typeof requiredFeatures[i] === 'undefined') {
      return false;
    }
  }
  return true;
}

module.exports = checkCompat;


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = shouldIgnoreOnError;
/* unused harmony export ignoreNextOnError */
/* harmony export (immutable) */ __webpack_exports__["c"] = wrap;
/* harmony export (immutable) */ __webpack_exports__["a"] = breadcrumbEventHandler;
/* harmony export (immutable) */ __webpack_exports__["b"] = keypressEventHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);



var debounceDuration = 1000;
var keypressTimeout;
var lastCapturedEvent;
var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    if (options === void 0) { options = {}; }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) {
            return fn;
        }
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) {
            return fn.__sentry_wrapped__;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    var sentryWrapped = function () {
        // tslint:disable-next-line:strict-type-predicates
        if (before && typeof before === 'function') {
            before.apply(this, arguments);
        }
        var args = Array.prototype.slice.call(arguments);
        // tslint:disable:no-unsafe-any
        try {
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            if (fn.handleEvent) {
                // Attempt to invoke user-land function
                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
                //       means the sentry.javascript SDK caught an error invoking your application code. This
                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
                return fn.handleEvent.apply(this, wrappedArguments);
            }
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
            // tslint:enable:no-unsafe-any
        }
        catch (ex) {
            ignoreNextOnError();
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["r" /* withScope */])(function (scope) {
                scope.addEventProcessor(function (event) {
                    var processedEvent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event);
                    if (options.mechanism) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* addExceptionTypeValue */])(processedEvent, undefined, undefined);
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["C" /* addExceptionMechanism */])(processedEvent, options.mechanism);
                    }
                    processedEvent.extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, processedEvent.extra, { arguments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["r" /* normalize */])(args, 3) });
                    return processedEvent;
                });
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["c" /* captureException */])(ex);
            });
            throw ex;
        }
    };
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // tslint:disable-line:no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, '__sentry_wrapped__', {
        enumerable: false,
        value: sentryWrapped,
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true,
        },
        __sentry_original__: {
            enumerable: false,
            value: fn,
        },
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
    }
    catch (_oO) {
        /*no-empty*/
    }
    return sentryWrapped;
}
var debounceTimer = 0;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param eventName the event name (e.g. "click")
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function breadcrumbEventHandler(eventName, debounce) {
    if (debounce === void 0) { debounce = false; }
    return function (event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        lastCapturedEvent = event;
        var captureBreadcrumb = function () {
            var target;
            // Accessing event.target can throw (see getsentry/raven-js#838, #768)
            try {
                target = event.target ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* htmlTreeAsString */])(event.target) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["D" /* htmlTreeAsString */])(event);
            }
            catch (e) {
                target = '<unknown>';
            }
            if (target.length === 0) {
                return;
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb({
                category: "ui." + eventName,
                message: target,
            }, {
                event: event,
                name: eventName,
            });
        };
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        if (debounce) {
            debounceTimer = setTimeout(captureBreadcrumb);
        }
        else {
            captureBreadcrumb();
        }
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @returns wrapped keypress events handler
 * @hidden
 */
function keypressEventHandler() {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function (event) {
        var target;
        try {
            target = event.target;
        }
        catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
            return;
        }
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!keypressTimeout) {
            breadcrumbEventHandler('input')(event);
        }
        clearTimeout(keypressTimeout);
        keypressTimeout = setTimeout(function () {
            keypressTimeout = undefined;
        }, debounceDuration);
    };
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {/* harmony export (immutable) */ __webpack_exports__["h"] = dynamicRequire;
/* harmony export (immutable) */ __webpack_exports__["g"] = isNodeEnv;
/* harmony export (immutable) */ __webpack_exports__["a"] = getGlobalObject;
/* harmony export (immutable) */ __webpack_exports__["f"] = uuid4;
/* harmony export (immutable) */ __webpack_exports__["i"] = parseUrl;
/* harmony export (immutable) */ __webpack_exports__["e"] = getEventDescription;
/* harmony export (immutable) */ __webpack_exports__["d"] = consoleSandbox;
/* harmony export (immutable) */ __webpack_exports__["j"] = addExceptionTypeValue;
/* harmony export (immutable) */ __webpack_exports__["k"] = addExceptionMechanism;
/* harmony export (immutable) */ __webpack_exports__["l"] = getLocationHref;
/* harmony export (immutable) */ __webpack_exports__["c"] = htmlTreeAsString;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseRetryAfterHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(9);

/**
 * Requires a module which is protected _against bundler minification.
 *
 * @param request The module path to resolve
 */
function dynamicRequire(mod, request) {
    // tslint:disable-next-line: no-unsafe-any
    return mod.require(request);
}
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // tslint:disable:strict-type-predicates
    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return (isNodeEnv()
        ? global
        : typeof window !== 'undefined'
            ? window
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // tslint:disable-next-line:no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // tslint:disable-next-line:no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line:no-bitwise
        var r = (Math.random() * 16) | 0;
        // tslint:disable-next-line:no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    if (event.message) {
        return event.message;
    }
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) {
            return exception.type + ": " + exception.value;
        }
        return exception.type || exception.value || event.event_id || '<unknown>';
    }
    return event.event_id || '<unknown>';
}
/** JSDoc */
function consoleSandbox(callback) {
    var global = getGlobalObject();
    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
    if (!('console' in global)) {
        return callback();
    }
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        if (level in global.console && originalConsole[level].__sentry__) {
            wrappedLevels[level] = originalConsole[level].__sentry_wrapped__;
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || '';
    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
}
/**
 * Adds exception mechanism to a given event.
 * @param event The event to modify.
 * @param mechanism Mechanism of the mechanism.
 * @hidden
 */
function addExceptionMechanism(event, mechanism) {
    if (mechanism === void 0) { mechanism = {}; }
    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
    try {
        // @ts-ignore
        // tslint:disable:no-non-null-assertion
        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
        Object.keys(mechanism).forEach(function (key) {
            // @ts-ignore
            event.exception.values[0].mechanism[key] = mechanism[key];
        });
    }
    catch (_oO) {
        // no-empty
    }
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    try {
        return document.location.href;
    }
    catch (oO) {
        return '';
    }
}
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push("#" + elem.id);
    }
    className = elem.className;
    if (className && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is__["h" /* isString */])(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push("." + classes[i]);
        }
    }
    var attrWhitelist = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < attrWhitelist.length; i++) {
        key = attrWhitelist[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
var defaultRetryAfter = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param now current unix timestamp
 * @param header string representation of 'Retry-After' header
 */
function parseRetryAfterHeader(now, header) {
    if (!header) {
        return defaultRetryAfter;
    }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return defaultRetryAfter;
}
//# sourceMappingURL=misc.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(110), __webpack_require__(13)))

/***/ }),
/* 13 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 14 */
/***/ (function(module, exports) {


const config = {
  liveStreamUrl: 'https://stream.bff.fm/1/mp3.mp3'
};

module.exports = config;


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeStackTrace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
// tslint:disable:object-literal-sort-keys

// global reference to slice
var UNKNOWN_FUNCTION = '?';
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[-a-z]+:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i;
var winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
/** JSDoc */
function computeStackTrace(ex) {
    // tslint:disable:no-unsafe-any
    var stack = null;
    var popSize = ex && ex.framesToPop;
    try {
        // This must be tried first because Opera 10 *destroys*
        // its stacktrace property if you try to access the stack
        // property first!!
        stack = computeStackTraceFromStacktraceProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    try {
        stack = computeStackTraceFromStackProp(ex);
        if (stack) {
            return popFrames(stack, popSize);
        }
    }
    catch (e) {
        // no-empty
    }
    return {
        message: extractMessage(ex),
        name: ex && ex.name,
        stack: [],
        failed: true,
    };
}
/** JSDoc */
// tslint:disable-next-line:cyclomatic-complexity
function computeStackTraceFromStackProp(ex) {
    // tslint:disable:no-conditional-assignment
    if (!ex || !ex.stack) {
        return null;
    }
    var stack = [];
    var lines = ex.stack.split('\n');
    var isEval;
    var submatch;
    var parts;
    var element;
    for (var i = 0; i < lines.length; ++i) {
        if ((parts = chrome.exec(lines[i]))) {
            var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
            isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = submatch[1]; // url
                parts[3] = submatch[2]; // line
                parts[4] = submatch[3]; // column
            }
            element = {
                url: parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: isNative ? [parts[2]] : [],
                line: parts[3] ? +parts[3] : null,
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = winjs.exec(lines[i]))) {
            element = {
                url: parts[2],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: [],
                line: +parts[3],
                column: parts[4] ? +parts[4] : null,
            };
        }
        else if ((parts = gecko.exec(lines[i]))) {
            isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = submatch[1];
                parts[4] = submatch[2];
                parts[5] = ''; // no column when eval
            }
            else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
                // FireFox uses this awesome columnNumber property for its top frame
                // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                // so adding 1
                // NOTE: this hack doesn't work if top-most frame is eval
                stack[0].column = ex.columnNumber + 1;
            }
            element = {
                url: parts[3],
                func: parts[1] || UNKNOWN_FUNCTION,
                args: parts[2] ? parts[2].split(',') : [],
                line: parts[4] ? +parts[4] : null,
                column: parts[5] ? +parts[5] : null,
            };
        }
        else {
            continue;
        }
        if (!element.func && element.line) {
            element.func = UNKNOWN_FUNCTION;
        }
        stack.push(element);
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** JSDoc */
function computeStackTraceFromStacktraceProp(ex) {
    if (!ex || !ex.stacktrace) {
        return null;
    }
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace;
    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i;
    var lines = stacktrace.split('\n');
    var stack = [];
    var parts;
    for (var line = 0; line < lines.length; line += 2) {
        // tslint:disable:no-conditional-assignment
        var element = null;
        if ((parts = opera10Regex.exec(lines[line]))) {
            element = {
                url: parts[2],
                func: parts[3],
                args: [],
                line: +parts[1],
                column: null,
            };
        }
        else if ((parts = opera11Regex.exec(lines[line]))) {
            element = {
                url: parts[6],
                func: parts[3] || parts[4],
                args: parts[5] ? parts[5].split(',') : [],
                line: +parts[1],
                column: +parts[2],
            };
        }
        if (element) {
            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }
            stack.push(element);
        }
    }
    if (!stack.length) {
        return null;
    }
    return {
        message: extractMessage(ex),
        name: ex.name,
        stack: stack,
    };
}
/** Remove N number of frames from the stack */
function popFrames(stacktrace, popSize) {
    try {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, stacktrace, { stack: stacktrace.stack.slice(popSize) });
    }
    catch (e) {
        return stacktrace;
    }
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["f" /* PromiseBuffer */](30);
        this.url = new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["t" /* API */](this.options.dsn).getStoreEndpointWithUrlEncodedAuth();
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (_) {
        throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["g" /* SentryError */]('Transport Class has to implement `sendEvent` method');
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    return BaseTransport;
}());

//# sourceMappingURL=base.js.map

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dsn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w\.-]+)(?::(\d+))?\/(.+)/;
/** Error message */
var ERROR_MESSAGE = 'Invalid Dsn';
/** The Sentry Dsn, identifying a Sentry instance and project. */
var Dsn = /** @class */ (function () {
    /** Creates a new Dsn component */
    function Dsn(from) {
        if (typeof from === 'string') {
            this._fromString(from);
        }
        else {
            this._fromComponents(from);
        }
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private _representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */
    Dsn.prototype.toString = function (withPassword) {
        if (withPassword === void 0) { withPassword = false; }
        // tslint:disable-next-line:no-this-assignment
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
    };
    /** Parses a string into this Dsn. */
    Dsn.prototype._fromString = function (str) {
        var match = DSN_REGEX.exec(str);
        if (!match) {
            throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["g" /* SentryError */](ERROR_MESSAGE);
        }
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __read */](match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        this._fromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
    };
    /** Maps Dsn components into this instance. */
    Dsn.prototype._fromComponents = function (components) {
        this.protocol = components.protocol;
        this.user = components.user;
        this.pass = components.pass || '';
        this.host = components.host;
        this.port = components.port || '';
        this.path = components.path || '';
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */
    Dsn.prototype._validate = function () {
        var _this = this;
        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
            if (!_this[component]) {
                throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["g" /* SentryError */](ERROR_MESSAGE);
            }
        });
        if (this.protocol !== 'http' && this.protocol !== 'https') {
            throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["g" /* SentryError */](ERROR_MESSAGE);
        }
        if (this.port && isNaN(parseInt(this.port, 10))) {
            throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["g" /* SentryError */](ERROR_MESSAGE);
        }
    };
    return Dsn;
}());

//# sourceMappingURL=dsn.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports = function addScrollEventListener(element, handler) {
  var scrollTicking = false;

  element.addEventListener('scroll', function (e) {
    if (scrollTicking) return;

    window.requestAnimationFrame(function () {
      handler(e);
      scrollTicking = false;
    });
    scrollTicking = true;
  });
};


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backend__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__version__ = __webpack_require__(24);





/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_3__backend__["a" /* BrowserBackend */], options) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        event.sdk = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event.sdk, { name: __WEBPACK_IMPORTED_MODULE_4__version__["a" /* SDK_NAME */], packages: __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](((event.sdk && event.sdk.packages) || []), [
                {
                    name: 'npm:@sentry/browser',
                    version: __WEBPACK_IMPORTED_MODULE_4__version__["b" /* SDK_VERSION */],
                },
            ]), version: __WEBPACK_IMPORTED_MODULE_4__version__["b" /* SDK_VERSION */] });
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["a" /* getGlobalObject */])().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* logger */].error('Trying to call showReportDialog with Sentry Client is disabled');
            return;
        }
        var dsn = options.dsn || this.getDsn();
        if (!options.eventId) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* logger */].error('Missing `eventId` option in showReportDialog call');
            return;
        }
        if (!dsn) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* logger */].error('Missing `Dsn` option in showReportDialog call');
            return;
        }
        var script = document.createElement('script');
        script.async = true;
        script.src = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["t" /* API */](dsn).getReportDialogEndpoint(options);
        if (options.onLoad) {
            script.onload = options.onLoad;
        }
        (document.head || document.body).appendChild(script);
    };
    return BrowserClient;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["v" /* BaseClient */]));

//# sourceMappingURL=client.js.map

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = eventFromUnknownInput;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parsers__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tracekit__ = __webpack_require__(15);



/** JSDoc */
function eventFromUnknownInput(exception, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* isErrorEvent */])(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        exception = errorEvent.error; // tslint:disable-line:no-parameter-reassignment
        event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__parsers__["b" /* eventFromStacktrace */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["G" /* isDOMError */])(exception) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["H" /* isDOMException */])(exception)) {
        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
        // then we just extract the name and message, as they don't provide anything else
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        var domException = exception;
        var name_1 = domException.name || (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["G" /* isDOMError */])(domException) ? 'DOMError' : 'DOMException');
        var message = domException.message ? name_1 + ": " + domException.message : name_1;
        event = eventFromString(message, syntheticException, options);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["B" /* addExceptionTypeValue */])(event, message);
        return event;
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["I" /* isError */])(exception)) {
        // we have a real Error object, do nothing
        event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__parsers__["b" /* eventFromStacktrace */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tracekit__["a" /* computeStackTrace */])(exception));
        return event;
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["J" /* isPlainObject */])(exception) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["s" /* isEvent */])(exception)) {
        // If it is plain Object or Event, serialize it manually and extract options
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        var objectException = exception;
        event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__parsers__["c" /* eventFromPlainObject */])(objectException, syntheticException, options.rejection);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["C" /* addExceptionMechanism */])(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, options);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["B" /* addExceptionTypeValue */])(event, "" + exception, undefined);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["C" /* addExceptionMechanism */])(event, {
        synthetic: true,
    });
    return event;
}
// this._options.attachStacktrace
/** JSDoc */
function eventFromString(input, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event = {
        message: input,
    };
    if (options.attachStacktrace && syntheticException) {
        var stacktrace = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__parsers__["d" /* prepareFramesForEvent */])(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
//# sourceMappingURL=eventbuilder.js.map

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalhandlers__ = __webpack_require__(82);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalHandlers", function() { return __WEBPACK_IMPORTED_MODULE_0__globalhandlers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trycatch__ = __webpack_require__(84);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TryCatch", function() { return __WEBPACK_IMPORTED_MODULE_1__trycatch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linkederrors__ = __webpack_require__(83);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedErrors", function() { return __WEBPACK_IMPORTED_MODULE_3__linkederrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useragent__ = __webpack_require__(85);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UserAgent", function() { return __WEBPACK_IMPORTED_MODULE_4__useragent__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = exceptionFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["c"] = eventFromPlainObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["d"] = prepareFramesForEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracekit__ = __webpack_require__(15);


var STACKTRACE_LIMIT = 50;
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromStacktrace(stacktrace) {
    var frames = prepareFramesForEvent(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message,
    };
    if (frames && frames.length) {
        exception.stacktrace = { frames: frames };
    }
    // tslint:disable-next-line:strict-type-predicates
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [
                {
                    type: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["s" /* isEvent */])(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["t" /* extractExceptionKeysForMessage */])(exception),
                },
            ],
        },
        extra: {
            __serialized__: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["u" /* normalizeToSize */])(exception),
        },
    };
    if (syntheticException) {
        var stacktrace = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__tracekit__["a" /* computeStackTrace */])(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
/**
 * @hidden
 */
function eventFromStacktrace(stacktrace) {
    var exception = exceptionFromStacktrace(stacktrace);
    return {
        exception: {
            values: [exception],
        },
    };
}
/**
 * @hidden
 */
function prepareFramesForEvent(stack) {
    if (!stack || !stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || '';
    var lastFrameFunction = localStack[localStack.length - 1].func || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .map(function (frame) { return ({
        colno: frame.column === null ? undefined : frame.column,
        filename: frame.url || localStack[0].url,
        function: frame.func || '?',
        in_app: true,
        lineno: frame.line === null ? undefined : frame.line,
    }); })
        .slice(0, STACKTRACE_LIMIT)
        .reverse();
}
//# sourceMappingURL=parsers.js.map

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(16);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BaseTransport", function() { return __WEBPACK_IMPORTED_MODULE_0__base__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FetchTransport", function() { return __WEBPACK_IMPORTED_MODULE_1__fetch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xhr__ = __webpack_require__(88);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "XHRTransport", function() { return __WEBPACK_IMPORTED_MODULE_2__xhr__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SDK_VERSION; });
var SDK_NAME = 'sentry.javascript.browser';
var SDK_VERSION = '5.9.1';
//# sourceMappingURL=version.js.map

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SyncPromise */].resolve({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: __WEBPACK_IMPORTED_MODULE_0__sentry_types__["b" /* Status */].Skipped,
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SyncPromise */].resolve(true);
    };
    return NoopTransport;
}());

//# sourceMappingURL=noop.js.map

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Scope; });
/* harmony export (immutable) */ __webpack_exports__["a"] = addGlobalEventProcessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__span__ = __webpack_require__(27);



/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifiying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._context = {};
    }
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            setTimeout(function () {
                _this._scopeListeners.forEach(function (callback) {
                    callback(_this);
                });
                _this._notifyingListeners = false;
            });
        }
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SyncPromise */](function (resolve, reject) {
            var processor = processors[index];
            // tslint:disable-next-line:strict-type-predicates
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event), hint);
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* isThenable */])(result)) {
                    result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* normalize */])(user);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* normalize */])(tags));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, (_a = {}, _a[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* normalize */])(value), _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extra) {
        this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* normalize */])(extra));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, (_a = {}, _a[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* normalize */])(extra), _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* normalize */])(fingerprint);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* normalize */])(level);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransaction = function (transaction) {
        this._transaction = transaction;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (name, context) {
        this._context[name] = context ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* normalize */])(context) : undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.startSpan = function (parentSpan) {
        var span = new __WEBPACK_IMPORTED_MODULE_2__span__["a" /* Span */]();
        span.setParent(parentSpan);
        this.setSpan(span);
        return span;
    };
    /**
     * Internal getter for Span, used in Hub.
     * @hidden
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](scope._breadcrumbs);
            newScope._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._tags);
            newScope._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._extra);
            newScope._context = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._context);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._transaction = scope._transaction;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._context = {};
        this._level = undefined;
        this._transaction = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var timestamp = new Date().getTime() / 1000;
        var mergedBreadcrumb = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ timestamp: timestamp }, breadcrumb);
        this._breadcrumbs =
            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
                ? __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](this._breadcrumbs, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* normalize */])(mergedBreadcrumb)]).slice(-maxBreadcrumbs)
                : __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](this._breadcrumbs, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* normalize */])(mergedBreadcrumb)]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._user, event.user);
        }
        if (this._context && Object.keys(this._context).length) {
            event.contexts = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._context, event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transaction) {
            event.transaction = this._transaction;
        }
        if (this._span) {
            event.contexts = event.contexts || {};
            event.contexts.trace = this._span;
        }
        this._applyFingerprint(event);
        event.breadcrumbs = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */]((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    return Scope;
}());

/**
 * Retruns the global event processors.
 */
function getGlobalEventProcessors() {
    var global = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["a" /* getGlobalObject */])();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TRACEPARENT_REGEXP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Span; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(2);

var TRACEPARENT_REGEXP = /^[ \t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \t]*$/;
/**
 * Span containg all data about a span
 */
var Span = /** @class */ (function () {
    function Span(_traceId, _spanId, _sampled, _parent) {
        if (_traceId === void 0) { _traceId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["l" /* uuid4 */])(); }
        if (_spanId === void 0) { _spanId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["l" /* uuid4 */])().substring(16); }
        this._traceId = _traceId;
        this._spanId = _spanId;
        this._sampled = _sampled;
        this._parent = _parent;
    }
    /**
     * Setter for parent
     */
    Span.prototype.setParent = function (parent) {
        this._parent = parent;
        return this;
    };
    /**
     * Setter for sampled
     */
    Span.prototype.setSampled = function (sampled) {
        this._sampled = sampled;
        return this;
    };
    /**
     * Continues a trace
     * @param traceparent Traceparent string
     */
    Span.fromTraceparent = function (traceparent) {
        var matches = traceparent.match(TRACEPARENT_REGEXP);
        if (matches) {
            var sampled = void 0;
            if (matches[3] === '1') {
                sampled = true;
            }
            else if (matches[3] === '0') {
                sampled = false;
            }
            var parent_1 = new Span(matches[1], matches[2], sampled);
            return new Span(matches[1], undefined, sampled, parent_1);
        }
        return undefined;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toTraceparent = function () {
        var sampled = '';
        if (this._sampled === true) {
            sampled = '-1';
        }
        else if (this._sampled === false) {
            sampled = '-0';
        }
        return this._traceId + "-" + this._spanId + sampled;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toJSON = function () {
        return {
            parent: (this._parent && this._parent.toJSON()) || undefined,
            sampled: this._sampled,
            span_id: this._spanId,
            trace_id: this._traceId,
        };
    };
    return Span;
}());

//# sourceMappingURL=span.js.map

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SentryError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfill__ = __webpack_require__(105);


/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        // tslint:disable:no-unsafe-any
        _this.name = _newTarget.prototype.constructor.name;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__polyfill__["a" /* setPrototypeOf */])(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

//# sourceMappingURL=error.js.map

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc__ = __webpack_require__(12);

// TODO: Implement different loggers for different environments
var global = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__misc__["a" /* getGlobalObject */])();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__misc__["d" /* consoleSandbox */])(function () {
            global.console.log(PREFIX + "[Log]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__misc__["d" /* consoleSandbox */])(function () {
            global.console.warn(PREFIX + "[Warn]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__misc__["d" /* consoleSandbox */])(function () {
            global.console.error(PREFIX + "[Error]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    return Logger;
}());
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());

//# sourceMappingURL=logger.js.map

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Memo; });
// tslint:disable:no-unsafe-any
/**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */
var Memo = /** @class */ (function () {
    function Memo() {
        // tslint:disable-next-line
        this._hasWeakSet = typeof WeakSet === 'function';
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */
    Memo.prototype.memoize = function (obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) {
                return true;
            }
            this._inner.add(obj);
            return false;
        }
        // tslint:disable-next-line:prefer-for-of
        for (var i = 0; i < this._inner.length; i++) {
            var value = this._inner[i];
            if (value === obj) {
                return true;
            }
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */
    Memo.prototype.unmemoize = function (obj) {
        if (this._hasWeakSet) {
            this._inner.delete(obj);
        }
        else {
            for (var i = 0; i < this._inner.length; i++) {
                if (this._inner[i] === obj) {
                    this._inner.splice(i, 1);
                    break;
                }
            }
        }
    };
    return Memo;
}());

//# sourceMappingURL=memo.js.map

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = truncate;
/* unused harmony export snipLine */
/* harmony export (immutable) */ __webpack_exports__["c"] = safeJoin;
/* harmony export (immutable) */ __webpack_exports__["b"] = isMatchingPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(9);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) {
        return newLine;
    }
    if (colno > ll) {
        colno = ll; // tslint:disable-line:no-parameter-reassignment
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) {
        end = ll;
    }
    if (end === ll) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < ll) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is__["b" /* isRegExp */])(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}
//# sourceMappingURL=string.js.map

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyncPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(9);

/** SyncPromise internal states */
var States;
(function (States) {
    /** Pending */
    States["PENDING"] = "PENDING";
    /** Resolved / OK */
    States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */
    States["REJECTED"] = "REJECTED";
})(States || (States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = States.PENDING;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(States.RESOLVED, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(States.REJECTED, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== States.PENDING) {
                return;
            }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is__["a" /* isThenable */])(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        // TODO: FIXME
        /** JSDoc */
        this._attachHandler = function (handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === States.PENDING) {
                return;
            }
            if (_this._state === States.REJECTED) {
                _this._handlers.forEach(function (handler) {
                    if (handler.onrejected) {
                        handler.onrejected(_this._value);
                    }
                });
            }
            else {
                _this._handlers.forEach(function (handler) {
                    if (handler.onfulfilled) {
                        // tslint:disable-next-line:no-unsafe-any
                        handler.onfulfilled(_this._value);
                    }
                });
            }
            _this._handlers = [];
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.toString = function () {
        return '[object SyncPromise]';
    };
    /** JSDoc */
    SyncPromise.resolve = function (value) {
        return new SyncPromise(function (resolve) {
            resolve(value);
        });
    };
    /** JSDoc */
    SyncPromise.reject = function (reason) {
        return new SyncPromise(function (_, reject) {
            reject(reason);
        });
    };
    /** JSDoc */
    SyncPromise.all = function (collection) {
        return new SyncPromise(function (resolve, reject) {
            if (!Array.isArray(collection)) {
                reject(new TypeError("Promise.all requires an array as input."));
                return;
            }
            if (collection.length === 0) {
                resolve([]);
                return;
            }
            var counter = collection.length;
            var resolvedCollection = [];
            collection.forEach(function (item, index) {
                SyncPromise.resolve(item)
                    .then(function (value) {
                    resolvedCollection[index] = value;
                    counter -= 1;
                    if (counter !== 0) {
                        return;
                    }
                    resolve(resolvedCollection);
                })
                    .then(null, reject);
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._attachHandler({
                onfulfilled: function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
                onrejected: function (reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                // tslint:disable-next-line:no-unsafe-any
                resolve(val);
            });
        });
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/* global __RELEASE__, __GITSHA__ */
/* The above variables are injected by Webpack during build */

function guessEnvironment() {
  var assetModifier;
  const serverEnv = serverEnvironment();

  if (serverEnv) {
    return serverEnv;
  }

  // Otherwise, fall back to implied environment name
  const domain = document.location.href.split('/')[2].replace(/\./g, '-');
  const build = buildType();

  if (build === 'unknown') {
    assetModifier = 'unknown-assets';
  } else if (build === 'production') {
    assetModifier = 'prod';
  } else {
    assetModifier = 'dev-assets';
  }
  return [domain, assetModifier].join('#');
}

function buildType() {
  const buildElement = document.querySelector('meta[name=build]');

  if (!buildElement) {
    return 'unknown';
  } else {
    return buildElement.content;
  }
}

function serverEnvironment() {
  const explicitEnvironment = document.querySelector('meta[name=environment]');

  // If the template tells us the environment name
  if (explicitEnvironment && explicitEnvironment.content) {
    return explicitEnvironment.content;
  }
}

function serverDeployTime() {
  const deployElement = document.querySelector('meta[name=deployed_at]');

  // If the template tells us the environment name
  if (deployElement) {
    return deployElement.content || 0;
  } else {
    return 0;
  }
}

function serverSha() {
  const shaElement = document.querySelector('meta[name=sha]');

  // If the template tells us the environment name
  if (shaElement) {
    return shaElement.content || 'Unknown';
  } else {
    return 'Unknown';
  }
}

function serverBranch() {
  const branchElement = document.querySelector('meta[name=branch]');

  // If the template tells us the environment name
  if (branchElement) {
    return branchElement.content || 'Unknown';
  } else {
    return 'Unknown';
  }
}

module.exports = {
  version: ( true) ? "v3.45.0" : 'UNDEFINED',
  jsSha: ( true) ? "70babd63adc6a46f5d5b24efe330acd3e09134d1" : 'UNDEFINED',
  build: buildType(),
  environment: guessEnvironment(),
  serverDeployTime: serverDeployTime(),
  serverSha: serverSha(),
  serverBranch: serverBranch()
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function addKeyPressEventListener(element, keyCode, handler) {
  element.addEventListener('keypress', function (e) {
    if (e.which !== keyCode) { return; }
    handler(e);
  });
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

const addScrollEventListener = __webpack_require__(18);
const events = __webpack_require__(0);

function SnapScroll(rootElement, contentViewElement, options) {
  var self = this;

  // Runtime vars
  // TODO: Babel + ES6 classes would be worthwhile here
  var root = rootElement;
  var contentView = contentViewElement;
  var scrollStartPosition = 0;
  var clientWidth = 0;
  var scrollWidth = 0;
  var itemWidth = 0;
  var offsetDistance = 0;
  var resetTimeout = null;
  var isScrolling = false;
  var isResetting = false;

  // TODO: Options object parser would be good here
  this.config = {
    scrollTriggerAt: options.scrollTriggerAt || 0.2,
    scrollLockTime: options.scrollingTimeout || 300,
    clipWidth: options.clipWidth || undefined,
    offsetDistance: options.offsetDistance || 0,
    scrollingLockClass: options.scrollingLockClass || 'is-scrolling'
  };

  function startScroll() {
    if (!isScrolling) {
      // Refresh dimensions once, at start of scroll gesture.
      refreshDimensions();
    }

    isScrolling = true;

    window.clearTimeout(resetTimeout);
    resetTimeout = window.setTimeout(function () {
      isScrolling = false;
      endScroll();
    }, 64); // 64ms ~~ 4 frames
  }

  function endScroll() {
    /* Resolves slide position & snaps to grid */
    snapToPage();
  }

  function refreshDimensions() {
    requestAnimationFrame(function () {
      // get dimensions
      clientWidth = contentView.clientWidth;
      scrollWidth = contentView.scrollWidth;
      itemWidth = self.config.clipWidth || contentView.firstElementChild.offsetWidth;
      offsetDistance = self.config.offsetDistance || 0;

      // update start position
      scrollStartPosition = root.scrollLeft;
    });
  }

  function turnPage(direction) {
    refreshDimensions();
    requestAnimationFrame(function () {
      const currentScrollPos = root.scrollLeft;
      const newPosition = (function () {
        switch (direction) {
          case SnapScroll.FORWARDS: return currentScrollPos + itemWidth;
          case SnapScroll.BACKWARDS: return currentScrollPos - itemWidth;
          default: return currentScrollPos;
        }
      }());
      resetScroll(newPosition);
    });
  }

  function goToPage(index) {
    refreshDimensions();

    requestAnimationFrame(function () {
      const newPosition = index * itemWidth;
      resetScroll(newPosition);
    });
  }

  function resetScroll(newPosition) {
    if (isResetting) { return; }

    isResetting = true;
    clearTimeout(resetTimeout);

    const maxPosition = scrollWidth - clientWidth;
    const misalignment = newPosition % itemWidth;
    const adjustment = misalignment > itemWidth * 0.5 ? (itemWidth - misalignment) : -misalignment;
    const roundedPosition = newPosition + adjustment;
    const offsetPosition = roundedPosition - offsetDistance;

    // If we scroll to the end at an imperfect width, don't jump backwards:
    // >= to handle elastic scrolling
    if (newPosition >= maxPosition) {
      animateScrollTo(maxPosition);
    } else {
      animateScrollTo(Math.max(0, Math.min(offsetPosition, maxPosition)));
    }
  }

  function animateScrollTo(newPosition) {
    requestAnimationFrame(function () {
      var fromPosition = root.scrollLeft;

      if (fromPosition === newPosition) {
        isResetting = false;
        isScrolling = false;
        return;
      }

      root.classList.add(self.config.scrollingLockClass);
      contentView.style.transform = ['translate(', fromPosition - newPosition, 'px, 0)'].join('');
      root.dispatchEvent(new CustomEvent(events.uiScrollSnap, {
        bubbles: true,
        detail: {
          scrollLeft: newPosition,
          pageIndex: Math.floor(newPosition / itemWidth)
        }
      }));

      setTimeout(function () {
        replaceNativeScrolling(newPosition);
      }, self.config.scrollLockTime);
    });
  }

  function replaceNativeScrolling(position) {
    requestAnimationFrame(function () {
      root.classList.remove(self.config.scrollingLockClass);
      contentView.style.transform = 'none';
      root.scrollLeft = position;

      isResetting = false;
      isScrolling = false;
    });
  }

  /**
   * After a natural scroll interaction, snap the scrollview back to alignment. This function
   * first determines whether to advance the slide forward based on the scroll trigger option,
   * then turns the page as appropriate.
   */
  function snapToPage() {
    const roundingAdjustment = 0.5 - self.config.scrollTriggerAt;

    requestAnimationFrame(function () {
      const currentScrollPos = root.scrollLeft;
      const scrollDifference = scrollStartPosition - currentScrollPos;
      const forward = scrollDifference < 0;
      const scrollPerItem = scrollDifference / itemWidth;
      const percentageScrolled = forward ? 1 - (1 + scrollPerItem) : scrollPerItem;

      // Trigger movement if we've moved enough of the view:
      // If we've scrolled greater than 50%, we already revealled the next slide and we
      // will snap to it without specifying advancement.
      const shouldAdvance = percentageScrolled < 0.5 && percentageScrolled + roundingAdjustment > 0.5;

      if (shouldAdvance) {
        turnPage(forward ? SnapScroll.FORWARDS : SnapScroll.BACKWARDS);
      } else {
        turnPage(/* current page */);
      }
    });
  }

  // BUG: This gets events from interial scrolling too, hence the delay in
  // reactivating scrolling after reset. Maybe try to detect and estimate that
  // in future.
  addScrollEventListener(root, function (/* scrollEvent */) {
    startScroll();
  });

  this.turnPage = turnPage;
  this.goToPage = goToPage;
}

SnapScroll.FORWARDS = 'F';
SnapScroll.BACKWARDS = 'B';

module.exports = SnapScroll;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

/** Event listener for Google Analytics & Tag Manager */
const events = __webpack_require__(0);
const EventTiming = __webpack_require__(122);
const googleAnalytics = __webpack_require__(111);

const TIMING_INCREMENT = 30;

var listeningTimestamps = {};

// Track total listening time: Array of start + current times.
const musicTiming = new EventTiming();
var lastTotalMusic = 0;

function AnalyticsMonitor() {
  // TODO: Pull Google Analytics ID from mark-up?
  googleAnalytics.initialize('UA-53665120-1');
  this.addTagManager();

  document.addEventListener('click', this.handleAllClicks);

  document.addEventListener(events.navigationRequestEnded, this.handleNavigationRequestEnded);
  document.addEventListener(events.uiDidSearch, this.handleSearch);

  document.addEventListener(events.audioSourcePlaying, this.handleMusicStart);
  document.addEventListener(events.audioSourcePaused, this.handleMusicPause);
  document.addEventListener(events.audioSourceEnded, this.handleMusicComplete);
  document.addEventListener(events.audioSourceTimeUpdate, this.handleMusicProgress);

  // Log Initial Page Impression
  this.initialImpression();
}

AnalyticsMonitor.prototype.addTagManager = function addTagManager() {
  const insertAt = document.getElementsByTagName('script')[0];
  const tagScript = document.createElement('script');
  const initialEvent = {
    'gtm.start': new Date().getTime(),
    event: 'gtm.js'
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(initialEvent);

  tagScript.async = true;

  // TODO: Pull tag manager ID from mark-up
  tagScript.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-5B4BJ7V';
  insertAt.parentNode.insertBefore(tagScript, insertAt);
};

AnalyticsMonitor.prototype.initialImpression = function initialImpression() {
  const newPath = location.pathname;
  googleAnalytics.set('page', newPath);
  googleAnalytics.pageview();
};

AnalyticsMonitor.prototype.legacyBrowserImpression = function legacyBrowserImpression() {
  googleAnalytics.event('browser', 'legacyBrowserPageView');
};

AnalyticsMonitor.prototype.handleAllClicks = function handleAllClicks(e) {
  var payload = {};
  // HACK: Sentry is reporting a lot of errors with the `closest` function. Add guards.
  // TODO: Log info about the cases when `closest` doesn't exist.
  const linkTarget = (e.target && e.target.closest) && (e.target.closest('A') || e.target.closest('BUTTON'));

  if (!linkTarget) { return; }

  const action = linkTarget.getAttribute('data-analytics-clickaction') || linkTarget.tagName === 'A' ? 'link' : 'button';

  const label = linkTarget.getAttribute('data-analytics-label') || linkTarget.href;

  if (!label) { return; }

  payload = { eventLabel: label };
  const value = linkTarget.getAttribute('data-analytics-value') || undefined;

  if (!isNaN(value)) {
    payload.eventValue = value;
  }

  googleAnalytics.event('click', action, payload);
};

AnalyticsMonitor.prototype.handleNavigationRequestEnded = function onNavigationRequestEnded(e) {
  const newPath = location.pathname;
  googleAnalytics.set('page', newPath);

  if (e.detail && e.detail.didNavigate) {
    googleAnalytics.pageview(newPath);
  } else {
    googleAnalytics.event('error', 'navigation', {
      eventLabel: e.detail && e.detail.url
    });
  }
};

AnalyticsMonitor.prototype.handleSearch = function handleSearch(e) {
  googleAnalytics.event('search', 'search', {
    eventLabel: e.detail && e.detail.query
  });
};

AnalyticsMonitor.prototype.handleMusicStart = function onMusicStart(e) {
  if (!e.detail) { return; }

  musicTiming.start();
  googleAnalytics.event('music', 'play', {
    eventLabel: e.detail.src
  });
};

AnalyticsMonitor.prototype.handleMusicPause = function onMusicPause(e) {
  if (!e.detail) { return; }

  musicTiming.extend();
  googleAnalytics.event('music', 'pause', {
    eventLabel: e.detail.src,
    eventValue: Math.floor(e.detail.time)
  });
};

AnalyticsMonitor.prototype.handleMusicComplete = function onMusicEnd(e) {
  if (!e.detail) { return; }

  musicTiming.extend();
  googleAnalytics.event('music', 'ended', {
    eventLabel: e.detail.src,
    eventValue: Math.floor(e.detail.time)
  });
};

AnalyticsMonitor.prototype.handleMusicProgress = function onMusicProgress(e) {
  musicTiming.extend();

  const trackSrc = e.detail && e.detail.src;
  if (trackSrc) {
    const time = e.detail.time;
    const windowedTime = Math.floor(time / TIMING_INCREMENT) * TIMING_INCREMENT;

    if (windowedTime > (listeningTimestamps[trackSrc] || 0)) {
      listeningTimestamps[trackSrc] = windowedTime;

      googleAnalytics.event('music', 'listening', {
        eventLabel: trackSrc,
        eventValue: windowedTime,
        nonInteraction: true
      });
    }
  }

  const windowedTotalMusic = Math.floor(musicTiming.total / TIMING_INCREMENT) * TIMING_INCREMENT;
  if (windowedTotalMusic > lastTotalMusic) {
    lastTotalMusic = windowedTotalMusic;
    googleAnalytics.event('music', 'total', {
      eventLabel: 'Session Total Music Playback',
      eventValue: Math.floor(windowedTotalMusic),
      nonInteraction: true
    });
  }
};

module.exports = AnalyticsMonitor;


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

/* Development helpers */
const runtime = __webpack_require__(33);

function Development() {
  /* eslint-disable no-console */
  if (!console || !console.info) {
    return;
  }

  const envIcon = runtime.environment === 'prod' ? '🚦' : '🚧';

  console.info('Server Info');
  console.info(envIcon + ' You\'re viewing BFF.fm on ' + runtime.environment);
  console.info('🕝 ' + runtime.serverDeployTime);
  console.info('🔀 ' + runtime.serverBranch);
  console.info('#️⃣ ' + runtime.serverSha);

  console.info('Theme Info');
  console.info('❄️ ' + runtime.version);
  console.info('#️⃣ ' + runtime.jsSha);

  /* eslint-enable no-console */
}

module.exports = Development;


/***/ }),
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const fetch = __webpack_require__(7);

function Navigation(root) {
  var listenTo = root.addEventListener ? root : root.body;
  var contentSelector = 'main';
  var initalPageTitle = document.querySelector('title').textContent;

  Object.defineProperty(this, 'rootElement', {
    get: function () { return root; }
  });

  Object.defineProperty(this, 'contentSelector', {
    get: function () { return contentSelector; },
    set: function (newSelector) { contentSelector = newSelector; }
  });

  listenTo.addEventListener('click', this.handleNavigationEvent.bind(this));
  window.addEventListener('popstate', this.handleHistoryEvent.bind(this));

  // Push initial state
  history.pushState({ url: location.href }, initalPageTitle, location.href);
}

Navigation.prototype.handleNavigationEvent = function (e) {
  var baseLocation = location.protocol + '//' + location.host;
  var linkTarget = e.target && e.target.closest && e.target.closest('A');

  // Some other component cancelled the event
  if (e.defaultPrevented) { return; }

  // If there's no link target, ignore:
  if (!linkTarget) { return; }

  // If the link points to a different domain, ignore:
  if (linkTarget.href.indexOf(baseLocation) !== 0) { return; }

  // If the link is to be opened in a new window, ignore:
  // HACK: We use explicit `getAttribute` rather than node.target as Firefox returns the
  // inherited value of <base target=_blank>
  if (linkTarget.getAttribute('target') === '_blank') { return; }

  // TODO: If link is a fragment on the same page

  // If the user is holding down a modifier key for new tab/download behaviour, ignore:
  if (e.ctrlKey || e.shiftKey || e.metaKey || e.altKey) { return; }

  e.preventDefault();

  this.navigateTo(linkTarget.href);
};

Navigation.prototype.handleHistoryEvent = function (e) {
  var previousUrl = e.state && e.state.url;

  if (previousUrl) {
    this.navigateTo(previousUrl, true, true);
  }
};

Navigation.prototype.navigateTo = function (url, useCache, didPopState) {
  var self = this;

  this.rootElement.dispatchEvent(new CustomEvent(events.navigationRequestStarted, {
    bubbles: true, detail: { url: url }
  }));

  // Cancel any request that's already happening
  if (this.currentRequest) {
    this.currentRequest.abort();
    this.currentRequest = undefined;
  }

  // If we clicked a link to *the same page*, don't do anything (but still trigger events)
  if (!didPopState && url === window.location.href) {
    self.rootElement.dispatchEvent(new CustomEvent(events.navigationRequestEnded, {
      bubbles: true,
      detail: {
        didNavigate: true,
        url: url
      }
    }));
    return;
  }

  // If we're navigating away, add the current content to the cache
  self.cacheCurrentPage();

  // Attempt to pull a previous page DOM from cache
  if (useCache && this.updatePageContentFromCache(url)) {
    return;
  }

  // Finally, fetch fresh content from the web
  this.currentRequest = fetch.get(url, { headers: { 'x-bff-content-update': '1' } }, {
    success: function (dom) {
      var newTitle = dom.querySelector('title');
      var newMain = dom.querySelector(self.contentSelector);
      var main;

      // If the returned page doesn't match this template, end and hard-refresh:
      if (!newTitle || !newMain) {
        main = document.querySelector(self.contentSelector);
        (main || document.body).dispatchEvent(new CustomEvent(events.navigationRequestEnded, {
          bubbles: true,
          detail: {
            didNavigate: false,
            url: url
          }
        }));
        window.location = url;
        return;
      }
      if (!useCache) {
        history.pushState({ url: url }, newTitle.textContent, url);
      }

      self.updatePageContent(url, newMain, newTitle.textContent);
    },
    failure: function () {
      // If this failed in any way, then fall back to navigating normally
      var main = document.querySelector(self.contentSelector);
      main.dispatchEvent(new CustomEvent(events.navigationRequestEnded, {
        bubbles: true,
        detail: {
          didNavigate: false,
          url: url
        }
      }));
      window.location = url;
    },
    progress: function (amount) {
      var main = document.querySelector(self.contentSelector);
      main.dispatchEvent(new CustomEvent(events.navigationRequestProgress, {
        bubbles: true,
        detail: {
          percentageComplete: amount,
          url: url
        }
      }));
    }
  });
};

Navigation.prototype.cacheCurrentPage = function () {
  // TODO: Complete content caching support
  return false;
  // const url = window.location.href;
  // const title = document.title;
  // const content = this.rootElement.querySelector(this.contentSelector);
};

Navigation.prototype.updatePageContent = function (url, newContent, title) {
  var main = this.rootElement.querySelector(this.contentSelector);
  document.title = title;
  main.parentNode.replaceChild(newContent, main);

  newContent.dispatchEvent(new CustomEvent(events.navigationRequestEnded, {
    bubbles: true,
    detail: {
      didNavigate: true,
      url: url
    }
  }));
};

// TODO: Complete content caching support
Navigation.prototype.updatePageContentFromCache = function (/* url */) {
  return false;
};

module.exports = Navigation;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

/** Integration of Sentry error logging */
const runtimeConfig = __webpack_require__(33);
const SentryBrowser = __webpack_require__(80);

function Sentry() {
  SentryBrowser.init({
    dsn: 'https://f2bd072297cd4928be7718175d22eda7@sentry.io/281119',
    debug: false,
    release: runtimeConfig.version,
    environment: runtimeConfig.environment,
    tags: { git_commit: runtimeConfig.jsSha },
    sampleRate: 1.0
  });
}

module.exports = Sentry;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

/** Verify if a user is logged in to Creek */
const fetch = __webpack_require__(7);
const ADMIN_TEST_URL = 'https://admin.bff.fm/admin/settings';

function checkAuth() {
  fetch.head(ADMIN_TEST_URL, { withCredentials: true }, {
    success: function receiveSettingsResponse(_, xhr) {
      if (xhr.status === 200) {
        document.body.className += ' u-isLoggedIn';
      }
    }
  });
}

module.exports = checkAuth;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

function loadFonts() {
  Array.prototype.forEach.call(document.querySelectorAll('link.fontstylesheet'), function (link) {
    link.rel = 'stylesheet';
  });
}

module.exports = {
  loadFonts: loadFonts
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

const AddFeed = forgeUiComponent('AddFeed', {
  subscribing: 'is-subscribing'
}, function AddFeedConstructor() {
  const self = this;
  const subscribeButton = this.element.querySelector('.AddFeed-subscribeButton') || document.createElement('div');

  this.element.addEventListener(events.uiModalDismiss, function () {
    self.subscribing = false;
  });

  subscribeButton.addEventListener('click', function openSubscribeDialog(e) {
    e.preventDefault();
    self.subscribing = true;
  });
});

module.exports = AddFeed;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

const AddReminder = forgeUiComponent('AddReminder', {
  subscribing: 'is-subscribing'
}, function PodcastInfoConstructor() {
  const self = this;
  const subscribeButton = this.element.querySelector('.AddReminder-subscribeButton') || document.createElement('div');

  this.element.addEventListener(events.uiModalDismiss, function () {
    self.subscribing = false;
  });

  subscribeButton.addEventListener('click', function openSubscribeDialog(e) {
    e.preventDefault();
    self.subscribing = true;
  });
});

module.exports = AddReminder;


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

const domready = __webpack_require__(5);
const forgeUiComponent = __webpack_require__(1);
const addScrollEventListener = __webpack_require__(18);
const BffLogo = __webpack_require__(126);

var BffMenuBar = forgeUiComponent('BFFMenuBar', {
  collapsed: 'is-collapsed'
}, function BffMenuBarConstructor() {
  var self = this;

  self.options.collapseThreshold = self.collapseThreshold || 100;
  self.options.minExpandedHeight = self.minExpandedHeight || 450;

  // TODO: This is v. broken encapsulation?
  this.logo = new BffLogo(self.element.querySelector('.BFFLogo'));

  addScrollEventListener(window, function () {
    self.handleEvent();
  });

  domready(function () { self.handleEvent(); });
});

BffMenuBar.prototype.handleEvent = function handleEvent() {
  const contentHeight = window.innerHeight;
  const forceCollapse = contentHeight < this.options.minExpandedHeight;
  const scrollPosition = window.scrollY || document.body.scrollTop;

  this.updateScroll(scrollPosition, forceCollapse);
};

BffMenuBar.prototype.updateScroll = function updateScroll(position, collapse) {
  if ((collapse || position > this.options.collapseThreshold) && !this.collapsed) {
    this.collapsed = true;
    this.logo.minimized = true;
  }
  if ((!collapse && position < this.options.collapseThreshold) && this.collapsed) {
    this.collapsed = false;
    this.logo.minimized = false;
  }
};

module.exports = BffMenuBar;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

const forgeUiComponent = __webpack_require__(1);

const ClampedContent = forgeUiComponent('ClampedContent', {
  expanded: 'is-expanded'
}, function ClampedContentConstructor() {
  const self = this;
  const expandButton = this.element.querySelector('.ClampedContent-showMoreButton') || document.createElement('div');

  expandButton.addEventListener('click', function releaseClamp(e) {
    e.preventDefault();
    self.expanded = true;
  });
});

module.exports = ClampedContent;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

const DonationConfirmation = forgeUiComponent('DonationConfirmation', {
  showing: 'is-showing',
  rewarding: 'is-rewarding'
}, function DonationConfirmationConstructor() {
  const self = this;

  const rewardOptions = this.element.querySelectorAll('.DonationConfirmation-rewardOption') || document.createElement('div');
  const rewardAmountElement = this.element.querySelector('.DonationConfirmation-rewardAmount') || document.createElement('span');

  var lastDonationAmount = 0;

  Object.defineProperty(this, 'rewardAmountText', {
    get: function getRewardAmount() {
      return rewardAmountElement.textContent || '';
    },
    set: function setRewardAmount(text) {
      if (text) {
        rewardAmountElement.textContent = '$' + text;
        this.rewarding = true;
      } else {
        rewardAmountElement.textContent = '';
        this.rewarding = false;
      }
    }
  });

  Object.defineProperty(this, 'lastDonation', {
    get: function getLastDonation() {
      return lastDonationAmount;
    }
  });

  window.addEventListener('message', function (ev) {
    if (ev.data === 'kindful-donation-complete') {
      self.showConfirmation();
    }
  }, false);

  document.addEventListener(events.donationStarted, function (e) {
    if (e.detail && e.detail.amount && !isNaN(e.detail.amount)) {
      lastDonationAmount = +e.detail.amount;

      self.rewardAmountText = lastDonationAmount;

      /* hide reward option buttons */
      Array.prototype.forEach.call(rewardOptions, function (element) {
        requestAnimationFrame(function () {
          element.classList.add('u-hidden');
        });
      });

      /* show the reward matching the closest tier */
      const itemAmountTier = Array.prototype.map.call(rewardOptions, function (element) {
        return element.getAttribute('data-reward-amount');
      }).filter(function (item) { return !!item; })
        .sort(function (a, b) { return +a > +b; })
        .reduce(function (currentValue, optionValue) {
          if (lastDonationAmount >= optionValue) {
            return optionValue;
          } else {
            return currentValue;
          }
        }, 0);

      const itemTierElement = self.element.querySelector('.DonationConfirmation-rewardOption[data-reward-amount="' + itemAmountTier + '"]');
      if (itemTierElement) {
        self.rewarding = true;
        requestAnimationFrame(function () {
          itemTierElement.classList.remove('u-hidden');
        });
      } else {
        self.rewarding = false;
      }
    } else {
      self.rewarding = false;
      lastDonationAmount = 0;
    }
  });

  this.element.addEventListener(events.uiModalDismiss, function () {
    self.showing = false;
  });
});

DonationConfirmation.prototype.showConfirmation = function showConfirmation() {
  this.showing = true;
};

module.exports = DonationConfirmation;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

const domready = __webpack_require__(5);
const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

const DonationPrompt = forgeUiComponent('DonationPrompt', {
  donating: 'is-donating',
  designated: 'is-designated'
}, function DonationPromptConstructor() {
  const self = this;
  const designationElement = this.element.querySelector('.DonationPrompt-designation') || document.createElement('div');

  Object.defineProperty(this, 'showDesignation', {
    get: function getDesignation() {
      const mainContent = document.querySelector('main');
      const mainDesignation = mainContent && mainContent.getAttribute('data-donation-show-designation');
      return mainDesignation || this.element.getAttribute('data-show-designation');
    }
  });

  Object.defineProperty(this, 'djDesignation', {
    get: function getDesignation() {
      const mainContent = document.querySelector('main');
      const mainDesignation = mainContent && mainContent.getAttribute('data-donation-dj-designation');
      return mainDesignation || this.element.getAttribute('data-dj-designation');
    }
  });

  Object.defineProperty(this, 'designationText', {
    get: function getDesignation() {
      return designationElement.textContent || '';
    },
    set: function setDesignation(text) {
      if (text) {
        designationElement.textContent = text;
        this.designated = true;
      } else {
        this.designated = false;
      }
    }
  });

  document.addEventListener(events.uiWantsDonation, function () {
    self.updateDesignation();
    self.donating = true;
  });

  this.element.addEventListener(events.uiModalDismiss, function () {
    self.donating = false;
    if (document.location.hash === '#support' || document.location.hash === '#monthly-support') {
      document.location.hash = '';
    }
  });

  domready(function checkForSupportFragment() {
    if (document.location.hash === '#support' || document.location.hash === '#monthly-support') {
      document.dispatchEvent(new CustomEvent(events.uiWantsDonation, { bubbles: true }));
    }
  });
});

DonationPrompt.prototype.updateDesignation = function updateDesignationText() {
  this.designationText = this.showDesignation || this.djDesignation || false;
};

module.exports = DonationPrompt;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

/** Provides UI for pushstate events */
const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

const LOADING_CLASS = 'is-loading';
const LOADED_CLASS = 'has-loaded';
const LOADED_INCREMENTS = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map(function (i) {
  return LOADED_CLASS + '-' + i;
});
const LOADED_UNKNOWN = 'unknown';
const LOADED_ALL_CLASSES = LOADED_INCREMENTS.concat(LOADED_CLASS, LOADED_UNKNOWN);

var DynamicDocument = forgeUiComponent('DynamicDocument', {}, function DynamicDocumentConstructor() {
  var self = this;
  var progress = 0;

  Object.defineProperty(this, 'loading', {
    get: function () { return self.element.classList.contains(LOADING_CLASS); },
    set: function (loading) {
      requestAnimationFrame(function () {
        self.element.classList.toggle(LOADING_CLASS, loading);
      });
      this.progress = 0;
    }
  });

  Object.defineProperty(this, 'progress', {
    get: function () { return progress; },
    set: function (newProgress) {
      var roundedValue = newProgress > -1 ? Math.round(newProgress / 10) * 10 : -1;

      if (roundedValue === 0) {
        requestAnimationFrame(function () {
          self.element.classList.remove.apply(self.element.classList, LOADED_ALL_CLASSES);
        });
      } else if (roundedValue === -1) {
        requestAnimationFrame(function () {
          self.element.classList.add(LOADED_CLASS, LOADED_UNKNOWN);
        });
      } else {
        requestAnimationFrame(function () {
          self.element.classList.add(LOADED_CLASS, [LOADED_CLASS, roundedValue].join('-'));
        });
      }
    }
  });

  document.addEventListener(events.navigationRequestStarted, function () {
    self.loading = true;
    self.progress = 10; // Minimum visible value
  });

  document.addEventListener(events.navigationRequestEnded, function (e) {
    if (e.detail.didNavigate) {
      self.progress = 100;
      requestAnimationFrame(function () {
        window.scrollTo(0, 0);
      });
    }
    self.loading = false;
  });

  document.addEventListener(events.navigationRequestProgress, function (e) {
    self.progress = e.detail.percentageComplete;
  });
});

module.exports = DynamicDocument;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

const domready = __webpack_require__(5);
const forgeUiComponent = __webpack_require__(1);
const addScrollEventListener = __webpack_require__(18);
const addKeyPressEventListener = __webpack_require__(34);
const events = __webpack_require__(0);

const MENU_ELEMENT_SELECTOR = '.FixedGlobalNav-mainMenu';

var FixedGlobalNav = forgeUiComponent('FixedGlobalNav', {
  scrolled: 'is-scrolled',
  menuShowing: 'is-menuShowing'
}, function FixedGlobalNavConstructor() {
  var self = this;
  var menuElement = self.element.querySelector(MENU_ELEMENT_SELECTOR);

  if (menuElement) {
    menuElement.addEventListener('click', function (e) {
      e.target.dispatchEvent(new CustomEvent(events.uiMainMenuToggled, {
        bubbles: true,
        detail: { isActive: false }
      }));
    });
  }

  domready(function checkInitialScrollPosition() {
    var lastScrollPosition = window.scrollY || document.body.scrollTop;
    self.updateScroll(lastScrollPosition);
  });

  addScrollEventListener(window, function () {
    var lastScrollPosition = window.scrollY || document.body.scrollTop;
    self.updateScroll(lastScrollPosition);
  });

  addKeyPressEventListener(document, 27, function (e) { // ESC key
    e.target.dispatchEvent(new CustomEvent(events.uiMainMenuToggled, {
      bubbles: true,
      detail: { isActive: false }
    }));
  });

  self.element.addEventListener(events.uiMainMenuToggled, self.handleMenuToggle.bind(self));
});

FixedGlobalNav.prototype.updateScroll = function updateScroll(position) {
  if (position > 0 && !this.scrolled) {
    this.scrolled = true;
  }
  if (position < 1 && this.scrolled) {
    this.scrolled = false;
  }
};

FixedGlobalNav.prototype.handleMenuToggle = function handleMenuToggle(ev) {
  this.menuShowing = ev.detail.isActive;
};

module.exports = FixedGlobalNav;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

const forgeUiComponent = __webpack_require__(1);
const events = __webpack_require__(0);

var Hamburger = forgeUiComponent('Hamburger', {
  menuActive: 'is-menuActive'
}, function HamburgerConstructor() {
  var self = this;

  self.element.addEventListener('click', self.handleClick.bind(self));

  document.addEventListener(events.uiMainMenuToggled, function (e) {
    self.menuActive = e.detail.isActive;
  });
});

Hamburger.prototype.triggerToggle = function triggerToggle() {
  this.element.dispatchEvent(new CustomEvent(events.uiMainMenuToggled, {
    bubbles: true,
    detail: { isActive: !this.menuActive }
  }));
};

Hamburger.prototype.handleClick = function handleClick(e) {
  e.preventDefault();
  this.triggerToggle();
};

module.exports = Hamburger;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

// Any link to this raw URL will trigger the Donation UI rather than the link target.
const HIJACK_URL_REGEX = /^https?:\/\/bestff.kindful.com(?:\/\?campaign=(\d+))?$/;

const InvokeDonation = forgeUiComponent('InvokeDonation', {}, function InvokeDonationConstructor() {
  const self = this;

  this.element.addEventListener('click', function (e) {
    self.element.dispatchEvent(new CustomEvent(events.uiWantsDonation, { bubbles: true }));
    e.preventDefault();
  });

  // Also invoke for any link that exactly matches HIJACK_URL
  document.body.addEventListener('click', function (e) {
    const linkTarget = e.target && e.target.closest && e.target.closest('A');
    if (linkTarget && HIJACK_URL_REGEX.test(linkTarget.href)) {
      e.preventDefault();
      const campaignId = RegExp.$1;
      const eventDetail = campaignId ? { campaign: campaignId } : {};
      self.element.dispatchEvent(new CustomEvent(events.uiWantsDonation, {
        bubbles: true,
        detail: eventDetail
      }));
    }
  });
});

module.exports = InvokeDonation;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

const SUCCESS_URL = 'https://aw.bff.fm/html/donation-success.html';
const WINDOW_WIDTH = 780;
const CORE_POPUP_OPTIONS = [
  'resizable',
  'width=' + WINDOW_WIDTH,
  'height=640',
  'alwaysRaised'
];

const URL_FIELD = 'custom1';
const SHOW_DESIGNATION_FIELD = 'custom2';
const DJ_DESIGNATION_FIELD = 'custom3';

const KindfulDonation = forgeUiComponent('KindfulDonation', {
  customAmount: 'is-customAmount'
}, function KindfulDonationConstructor() {
  const self = this;

  const amountFieldset = this.element.querySelector('.KindfulDonation-amount') || document.createElement('div');
  const otherAmountInput = this.element.querySelector('.KindfulDonation-customAmount') || document.createElement('input');
  const otherAmountRadio = this.element.querySelector('.KindfulDonation-customDonationRadio') || document.createElement('input');
  const initalRadio = this.element.querySelectorAll('input[name="cart[items][0][amount]"]')[1] || document.createElement('input');
  const recurringCheckbox = this.element.querySelector('input[name=schedule]') || document.createElement('input');
  var currentCampaignId = (this.element.querySelector('input[name=campaign_id]') && this.element.querySelector('input[name=campaign_id]').value) || 0

  Object.defineProperty(this, 'showDesignation', {
    get: function getDesignation() {
      const mainContent = document.querySelector('main');
      const mainDesignation = mainContent && mainContent.getAttribute('data-donation-show-designation');
      return mainDesignation || this.element.getAttribute('data-show-designation');
    }
  });

  Object.defineProperty(this, 'djDesignation', {
    get: function getDesignation() {
      const mainContent = document.querySelector('main');
      const mainDesignation = mainContent && mainContent.getAttribute('data-donation-dj-designation');
      return mainDesignation || this.element.getAttribute('data-dj-designation');
    }
  });

  Object.defineProperty(this, 'donationProductId', {
    get: function getDesignation() {
      const mainContent = document.querySelector('main');
      const mainDonationId = mainContent && mainContent.getAttribute('data-donation-id');
      return mainDonationId || this.element.getAttribute('data-id');
    }
  });

  Object.defineProperty(this, 'wantsRecurringDonation', {
    get: function getRecurring() {
      return !!this.element.querySelector('input[name=schedule]:checked');
    }
  });

  Object.defineProperty(this, 'donationAmount', {
    get: function getDonationAmount() {
      const selectedRadio = this.element.querySelector('input[name="cart[items][0][amount]"]:checked');
      // Event handler below ensures that otherAmountInput.value is cleared if a preset radio is checked.
      return otherAmountInput.value || selectedRadio.value;
    }
  });

  Object.defineProperty(this, 'baseUrl', {
    get: function getBaseUrl() {
      return this.element.action;
    }
  });

  Object.defineProperty(this, 'campaignId', {
    get: function getCampaignId() {
      return currentCampaignId;
    },
    set: function setCampaignId(newId) {
      if (!newId || isNaN(newId)) {
        currentCampaignId = (this.element.querySelector('input[name=campaign_id]') && this.element.querySelector('input[name=campaign_id]').value) || 0;
      } else {
        currentCampaignId = newId;
      }
    }
  });

  document.addEventListener(events.uiWantsDonation, function (e) {
    // Uncheck “Make recurring” unless special URL used
    recurringCheckbox.checked = (document.location.hash === '#monthly-support');
    initalRadio.checked = true;
    self.customAmount = false;

    if (otherAmountInput.value > 0) {
      otherAmountInput.required = false;
      otherAmountInput.value = '';
    }

    // set the campaign ID
    self.campaignId = e.detail && e.detail.campaign;
  }, false);

  window.addEventListener('message', function (ev) {
    if (ev.data === 'kindful-donation-complete') {
      self.element.dispatchEvent(new CustomEvent(events.uiModalDismiss, { bubbles: true }));
    }
  }, false);

  this.element.addEventListener('submit', function (ev) {
    ev.preventDefault();

    const amount = self.donationAmount;

    if (amount > 0) {
      const url = self.buildPopupUrl(amount);
      self.element.dispatchEvent(new CustomEvent(events.donationStarted, {
        bubbles: true,
        detail: {
          amount: amount
        }
      }));

      self.popupKindful(url);
    } else {
      /* eslint-disable no-alert */
      window.alert('Please choose or enter an amount to donate. Thank you!');
      /* eslint-enable no-alert */
    }
  });

  // Handle entering custom amounts vs. radio buttons
  // If the custom input has a value set, then set the component class, and shift
  // radio focus to the hidden “custom amount” radio.
  // If a radio is hit, clear the value of the custom field and unset the component class.
  amountFieldset.addEventListener('change', function listenForRadioChange(ev) {
    if (!ev.target) return;

    if (ev.target === otherAmountInput && ev.target.value > 0) {
      self.customAmount = true;
      otherAmountRadio.checked = true;
      otherAmountInput.required = true;
    } else if (ev.target !== otherAmountRadio) {
      self.customAmount = false;
      otherAmountInput.required = false;
      otherAmountInput.value = '';
    }
  }, false);

  otherAmountInput.addEventListener('keydown', function listenForAmountKeyPress() {
    if (!self.customAmount) {
      self.customAmount = true;
      otherAmountRadio.checked = true;
      otherAmountInput.required = true;
    }
  });
});

KindfulDonation.prototype.buildPopupUrl = function makePopupUrl(amount) {
  var params = {
    campaign_id: this.campaignId,
    'cart[desc]': 'Donation to BFF.fm',
    custom_answers: 'true'
  };

  params['cart[items][0][amount]'] = amount;
  params['cart[items][0][quantity]'] = '1';

  if (this.showDesignation) {
    params['cart[items][0][desc]'] = 'BFF.fm Donation (supporting ' + this.showDesignation + ')';
  } else if (this.djDesignation) {
    params['cart[items][0][desc]'] = 'BFF.fm Donation (via DJ ' + this.djDesignation + ')';
  } else {
    params['cart[items][0][desc]'] = 'BFF.fm Donation';
  }

  if (this.donationProductId) {
    params['cart[items][0][product_id]'] = this.donationProductId;
  } else {
    params['cart[items][0][product_id]'] = 'default-donation';
  }

  if (this.wantsRecurringDonation) {
    params.schedule = '1';
    params.bill_today = 'true';
  }

  if (this.showDesignation) {
    params[SHOW_DESIGNATION_FIELD] = this.showDesignation;
  } else if (this.djDesignation) {
    params[DJ_DESIGNATION_FIELD] = this.djDesignation;
  }

  params[URL_FIELD] = document.location.href;
  params.success_url = SUCCESS_URL;
  params.success_action = 'GET';

  const serializedParams = Object.keys(params).map(function (k) {
    return [k, encodeURIComponent(params[k])].join('=');
  }).join('&');

  return [this.baseUrl, serializedParams].join('?');
};

KindfulDonation.prototype.popupKindful = function popupKindfulFlow(url) {
  const self = this;
  const posX = ((window.outerWidth / 2) + window.screenX) - Math.floor(WINDOW_WIDTH / 2);
  const posY = window.screenY + 40;

  const finalFeatures = CORE_POPUP_OPTIONS.concat([
    'left=' + posX,
    'top=' + posY
  ]).join(',');

  const popup = window.open(url, '_blank', finalFeatures);

  const listenForClose = window.setInterval(function isPopupClosed() {
    if (popup.closed) {
      window.clearInterval(listenForClose);
      self.element.dispatchEvent(new CustomEvent(events.donationEnded, { bubbles: true }));
      self.element.dispatchEvent(new CustomEvent(events.uiModalDismiss, { bubbles: true }));
    }
  }, 500);
};

module.exports = KindfulDonation;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

// TODO: DRY pop-up configuration
const SUCCESS_URL = 'https://aw.bff.fm/html/donation-success.html';
const WINDOW_WIDTH = 780;
const CORE_POPUP_OPTIONS = [
  'resizable',
  'width=' + WINDOW_WIDTH,
  'height=640',
  'alwaysRaised'
];

// Any link to a Kindful widget URL will inject it into a pop-up rather than new window
const HIJACK_URL_REGEX = /^https?:\/\/bestff.kindful.com\/widget/;
const AMOUNT_REGEX = /\[amount\]=(\d+)/;

const KindfulLinkHandler = forgeUiComponent('KindfulLinkHandler', {}, function KindfulLinkHandlerConstructor() {
  const self = this;

  document.addEventListener('click', function (e) {
    const linkTarget = e.target && e.target.closest && e.target.closest('A');

    // Some other component cancelled the event
    if (e.defaultPrevented) { return; }

    // If there's no link target, ignore:
    if (!linkTarget) { return; }

    // If the link points to a different domain, ignore:
    if (!HIJACK_URL_REGEX.test(linkTarget.href)) { return; }

    // If the user is holding down a modifier key for new tab/download behaviour, ignore:
    if (e.ctrlKey || e.shiftKey || e.metaKey || e.altKey) { return; }

    if (AMOUNT_REGEX.test(linkTarget.href)) {
      const donationAmount = RegExp.$1;
      linkTarget.dispatchEvent(new CustomEvent(events.donationStarted, {
        bubbles: true,
        detail: {
          amount: donationAmount
        }
      }));
    }

    const popupUrl = self.buildPopupUrl(linkTarget.href);
    self.popupKindful(popupUrl);

    e.preventDefault();
  }, false);
});

KindfulLinkHandler.prototype.buildPopupUrl = function makePopupUrl(baseWidgetUrl) {
  var params = {};

  if (baseWidgetUrl.indexOf('cart[desc]') === -1) {
    params['cart[desc]'] = 'Donation to BFF.fm';
  }

  params.success_url = SUCCESS_URL;
  params.success_action = 'GET';

  const serializedParams = Object.keys(params).map(function (k) {
    return [k, encodeURIComponent(params[k])].join('=');
  }).join('&');

  // HACK: These URLs should already contain params so we just append to the end
  return [baseWidgetUrl, serializedParams].join('&');
};

KindfulLinkHandler.prototype.popupKindful = function popupKindfulFlow(url) {
  const posX = ((window.outerWidth / 2) + window.screenX) - Math.floor(WINDOW_WIDTH / 2);
  const posY = window.screenY + 40;

  const finalFeatures = CORE_POPUP_OPTIONS.concat([
    'left=' + posX,
    'top=' + posY
  ]).join(',');

  window.open(url, '_blank', finalFeatures);
};

// Unlike other UIComponents, Twitter widgets are initialized within the element root,
// so we always return one component that may or may not contain widgets later.
//
// TODO: DRY: Make this a `Discoverable` mix-in
KindfulLinkHandler.discover = function (root) {
  return {
    components: [new KindfulLinkHandler(root)],
    errors: []
  };
};

module.exports = KindfulLinkHandler;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

const forgeUiComponent = __webpack_require__(1);
const SnapScroll = __webpack_require__(35);

var MiniSchedule = forgeUiComponent('MiniSchedule', {}, function MiniScheduleConstructor() {
  var self = this;
  const snapScroller = self.element.querySelector('.SnapScroll');
  const snapScrollContent = self.element.querySelector('.SnapScroll-content');
  const snapScrollOptions = {
    clipWidth: this.options.clipWidth || 200,
    offsetDistance: this.options.offsetDistance || 20
  };
  new SnapScroll(snapScroller, snapScrollContent, snapScrollOptions);
});

module.exports = MiniSchedule;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

const addKeyPressEventListener = __webpack_require__(34);
const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);


const Modal = forgeUiComponent('Modal', {}, function ModalConstructor() {
  const self = this;
  const content = self.element.querySelector('.Modal-content') || document.createElement('div');

  function dispatchDismiss() {
    self.element.dispatchEvent(new CustomEvent(events.uiModalDismiss, {
      bubbles: true
    }));
  }

  this.element.addEventListener('click', function (e) {
    if (content === e.target || content.contains(e.target)) {
      return;
    }
    e.stopPropagation();
    e.preventDefault();
    dispatchDismiss();
  });

  addKeyPressEventListener(document, 27, function () { // ESC key
    dispatchDismiss();
  });

  document.addEventListener(events.navigationRequestEnded, function dismissAfterNavigate() {
    dispatchDismiss();
  });
});

module.exports = Modal;


/***/ }),
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

const bffConfig = __webpack_require__(14);
const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);
const NotificationsGroup = __webpack_require__(127);

const ACTIVE_INFO_CLASS = 'is-active';
const ENABLED_GROUP_CLASS = 'is-enabled';

var NotificationsTicker = forgeUiComponent('NotificationsTicker', {}, function NotificationsTickerConstructor() {
  var self = this;
  // HACK: Global query rather than component content
  var liveStreamElement = document.getElementById('notificationsLiveStream');
  var archiveTrackElement = document.getElementById('notificationsArchivedTrack');

  var playingArchive = 0;

  /* HACK: We basically are just hard-coding two source types: The live stream and “other”
   * and assuming that if we get an “other” update event then it replaces whatever was there
   * before. Which is probably fine?
   */

  function markArchivePlaying(playing) {
    if (playing) {
      playingArchive = 5000 + Date.now();
    } else {
      playingArchive = 0;
    }
  }

  function activatePlayingGroup() {
    if (Date.now() < playingArchive) {
      self.activateGroup(archiveTrackElement);
    } else {
      self.activateGroup(liveStreamElement);
    }
  }

  /* TODO: Create a virtual notification group that maps to browser notifications */
  new NotificationsGroup(liveStreamElement, {
    // HACK: Passing bindings in as `options` is probably overloaded?
    bindRecieveMetadataUpdate: function (cb) {
      document.addEventListener(events.audioSourceMetadataUpdate, function (e) {
        if (e.detail && e.detail.src !== bffConfig.liveStreamUrl) { return; }
        cb(e.detail.metadata);
      });
    },
    bindRecieveProgressUpdate: function () {
      document.addEventListener(events.audioSourceTimeUpdate, function (e) {
        if (e.detail && e.detail.src !== bffConfig.liveStreamUrl) { return; }

        markArchivePlaying(false);
      });
    }
  });

  new NotificationsGroup(archiveTrackElement, {
    bindRecieveMetadataUpdate: function (cb) {
      document.addEventListener(events.audioSourceMetadataUpdate, function (e) {
        if (e.detail && e.detail.src === bffConfig.liveStreamUrl) { return; }
        cb(e.detail.metadata);
      });

      // disable with empty metadata when ending:
      document.addEventListener(events.audioSourceEnded, function (e) {
        if (e.detail && e.detail.src === bffConfig.liveStreamUrl) { return; }

        markArchivePlaying(false);
        cb({});
      });
      // disable with empty metadata when switching back to live stream:
      document.addEventListener(events.audioCued, function (e) {
        if (e.detail && e.detail.src !== bffConfig.liveStreamUrl) { return; }

        markArchivePlaying(false);
        cb({});
      });
    },
    bindRecieveProgressUpdate: function (cb) {
      document.addEventListener(events.audioSourceTimeUpdate, function (e) {
        if (e.detail && e.detail.src === bffConfig.liveStreamUrl) { return; }

        markArchivePlaying(true);
        cb({
          duration: e.detail.duration,
          time: e.detail.time
        });
      });
    }
  });
  setInterval(function () { activatePlayingGroup(); }, 2000);
  setInterval(function () { self.tick(); }, 5000);
});

NotificationsTicker.prototype.tick = function tick() {
  // Get current and next panel:
  var activePanel = this.element.querySelector('.NotificationsTicker-group.is-enabled .NotificationsTicker-info.is-active');
  var nextPanel =
    this.element.querySelector('.NotificationsTicker-group.is-enabled .NotificationsTicker-info.is-active + .NotificationsTicker-info') ||
    this.element.querySelector('.NotificationsTicker-group.is-enabled .NotificationsTicker-info:first-child');

  if (activePanel) {
    requestAnimationFrame(function () {
      activePanel.classList.remove(ACTIVE_INFO_CLASS);
    });
  }
  if (nextPanel) {
    requestAnimationFrame(function () {
      nextPanel.classList.add(ACTIVE_INFO_CLASS);
    });
  }
};

NotificationsTicker.prototype.activateGroup = function activateGroup(groupElement) {
  // Deactive other group
  const currentGroup = this.element.querySelector('.NotificationsTicker-group.is-enabled');

  if (currentGroup === groupElement) {
    return;
  }
  if (currentGroup) {
    requestAnimationFrame(function () {
      currentGroup.classList.remove(ENABLED_GROUP_CLASS);
    });
  }
  if (groupElement) {
    requestAnimationFrame(function () {
      groupElement.classList.add(ENABLED_GROUP_CLASS);
    });
  }
};

module.exports = NotificationsTicker;


/***/ }),
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

const PodcastInfo = forgeUiComponent('PodcastInfo', {
  subscribing: 'is-subscribing'
}, function PodcastInfoConstructor() {
  const self = this;
  const subscribeButton = this.element.querySelector('.PodcastInfo-subscribeButton') || document.createElement('div');

  this.element.addEventListener(events.uiModalDismiss, function () {
    self.subscribing = false;
  });

  subscribeButton.addEventListener('click', function openSubscribeDialog(e) {
    e.preventDefault();
    self.subscribing = true;
  });
});

module.exports = PodcastInfo;


/***/ }),
/* 67 */,
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

const forgeUiComponent = __webpack_require__(1);

var ScheduleNavigation = forgeUiComponent('ScheduleNavigation', {
  browsingGenre: 'is-browsingGenre'
}, function ScheduleNavigationConstructor() {
  const self = this;
  var genreLink = this.element.querySelector('.ScheduleNavigation-genreLink') || document.createElement('a');

  // TODO: Reset scroll position of submenus

  genreLink.addEventListener('click', function (event) {
    event.preventDefault();
    self.browsingGenre = !self.browsingGenre;
  });
});

module.exports = ScheduleNavigation;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

const forgeUiComponent = __webpack_require__(1);

const POPUP_WIDTH = 520;
const POPUP_HEIGHT = 550;

var SharePopup = forgeUiComponent('SharePopup', {}, function SharePopupConstructor() {
  var self = this;

  this.element.addEventListener('click', function (e) {
    e.preventDefault();
    self.openURL(self.finalizeLink(self.element.href));
  });
});

SharePopup.prototype.finalizeLink = function finalizeLink(url) {
  // Live update with the current URL
  return url.replace(encodeURIComponent('{{link}}'), encodeURIComponent(location.href));
};

SharePopup.prototype.isWebTarget = function isWebTarget() {
  return this.element.href.indexOf('http') === 0;
};

SharePopup.prototype.openURL = function openURL(url) {
  if (this.isWebTarget()) {
    window.open(url, null, this.windowOptions());
  } else {
    location.href = url;
  }
};

SharePopup.prototype.windowOptions = function windowOptions() {
  const options = {
    width: POPUP_WIDTH,
    height: POPUP_HEIGHT,
    personalbar: 0,
    toolbar: 0,
    location: 1,
    scrollbars: 1,
    resizable: 1,
    left: (Math.floor(window.outerWidth / 2) - Math.floor(POPUP_WIDTH / 2)) + window.screenLeft,
    top: (Math.floor(window.outerHeight / 2) - Math.floor(POPUP_HEIGHT / 2)) + window.screenTop
  };

  return Object.keys(options).map(function (key) {
    return key + '=' + options[key];
  }).join(',');
};

module.exports = SharePopup;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

const forgeUiComponent = __webpack_require__(1);

var ShowsGrid = forgeUiComponent('ShowsGrid', {}, function ShowsGridConstructor() {
  var self = this;
  // Generate background image elements for shows
  [].forEach.call(self.element.querySelectorAll('.program'), self.generateBackgroundImage);
});

ShowsGrid.prototype.generateBackgroundImage = function generateBackgroundImage(showElement) {
  var imageContainer = showElement.querySelector('.image-container');
  var showLogo = imageContainer && imageContainer.querySelector('img');
  var newImg;

  if (!showLogo) return;

  newImg = new Image();
  newImg.src = showLogo.src;
  newImg.alt = '';
  newImg.className = 'ShowsGrid-programImageFill';

  imageContainer.appendChild(newImg);
};

module.exports = ShowsGrid;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

var SiteSearch = forgeUiComponent('SiteSearch', {}, function SiteSearchConstructor() {
  const self = this;
  const input = this.element.querySelector('.SiteSearch-box') || document.createElement('input');

  this.element.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const query = input.value;

    if (!query) { return; }

    const fullQuery = [query, self.extraQueryString].join(' ');
    const searchUrl = [
      self.element.action,
      '?q=',
      encodeURIComponent(fullQuery)
    ].join('');

    window.open(searchUrl);

    document.dispatchEvent(new CustomEvent(events.uiDidSearch, {
      detail: {
        query: query
      }
    }));
  });

  this.element.addEventListener('click', function (e) {
    // HACK: Prevent main menu closing when focusing on search box
    e.stopPropagation();
  });

  Object.defineProperty(this, 'extraQueryString', {
    get: function getTrackId() { return this.element.getAttribute('data-extra-query'); }
  });
});

module.exports = SiteSearch;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

/** SlideDeck
  *
  * A UI controller for paged slidedeck/carousel UI.
  *
  * Required mixins: SnapScroll component
  * Assumes: Equal sized slides, no slide margins
  */
const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);
const SnapScroll = __webpack_require__(35);

var SlideDeck = forgeUiComponent('SlideDeck', {}, function SlideDeckConstructor() {
  var self = this;
  const slides = self.element.querySelector('.SlideDeck-slides');

  const snapScrollEl = self.element.querySelector('.SnapScroll');
  const snapScrollContentEl = self.element.querySelector('.SnapScroll-content');
  const snapScrollOptions = {};
  const snapScroller = new SnapScroll(snapScrollEl, snapScrollContentEl, snapScrollOptions);

  const paginationElement = self.element.querySelector('.SlideDeck-pagination');
  const nextButton = self.element.querySelector('.SlideDeck-nextSlide');
  const previousButton = self.element.querySelector('.SlideDeck-previousSlide');

  Object.defineProperty(this, 'slidesContainer', {
    get: function getSlidesElement() { return slides; }
  });

  Object.defineProperty(this, 'paginationContainer', {
    get: function getPaginationElement() { return paginationElement; }
  });

  Object.defineProperty(this, 'snapScroller', {
    get: function getSlidesElement() { return snapScroller; }
  });

  if (paginationElement) {
    paginationElement.addEventListener('click', function (e) {
      const btn = e.target && e.target.closest && e.target.closest('BUTTON');
      if (!btn) { return; }

      const page = btn.getAttribute('data-target');
      self.snapScroller.goToPage(page);
    });

    self.generatePagination();
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      snapScroller.turnPage(SnapScroll.FORWARDS);
    });
  }

  if (previousButton) {
    previousButton.addEventListener('click', function () {
      snapScroller.turnPage(SnapScroll.BACKWARDS);
    });
  }

  self.element.addEventListener(events.uiScrollSnap, function (e) {
    self.highlightSelectedPage(e.detail.pageIndex);
  });
});

SlideDeck.prototype.generatePagination = function generatePagination() {
  var self = this;
  if (!self.paginationContainer) { return; }

  const pips = document.createDocumentFragment();

  Array.prototype.forEach.call(self.slidesContainer.children, function (child, index) {
    var li = document.createElement('li');
    var button = document.createElement('button');

    li.className = 'SlideDeck-paginationItem';

    button.setAttribute('data-target', index);
    button.className = 'Pip';
    button.textContent = index;

    li.appendChild(button);
    pips.appendChild(li);
  });

  requestAnimationFrame(function () {
    self.paginationContainer.innerHTML = '';
    self.paginationContainer.appendChild(pips);
    self.highlightSelectedPage(0);
  });
};

SlideDeck.prototype.highlightSelectedPage = function highlightSelectedPage(selectedIndex) {
  var self = this;
  if (self.paginationContainer) {
    Array.prototype.forEach.call(self.paginationContainer.querySelectorAll('.Pip'), function (pip, index) {
      requestAnimationFrame(function () {
        pip.classList.toggle('Pip--selected', index === selectedIndex);
      });
    });
  }
};

module.exports = SlideDeck;


/***/ }),
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);
const Clipboard = __webpack_require__(108);

const SubscribeDialog = forgeUiComponent('SubscribeDialog', {}, function SubscribeDialogConstructor() {
  const urlElement = this.element.querySelector('.SubscribeDialog-url') || document.createElement('samp');

  Object.defineProperty(this, 'feedUrl', {
    get: function getFeedUrl() {
      return urlElement.textContent.trim();
    }
  });

  this.bindClipboard();
});

SubscribeDialog.prototype.bindClipboard = function bindClipboardAction() {
  const self = this;
  const copyBtn = this.element.querySelector('.SubscribeDialog-copyUrl');

  if (Clipboard.isSupported()) {
    const clippy = new Clipboard(copyBtn, {
      container: this.element,
      text: function getTextForClipboard() { return self.feedUrl; }
    });
    clippy.on('success', function successfullyCopied() {
      /* eslint-disable no-alert */
      window.alert('URL copied!');
      /* eslint-enable no-alert */
    });
    clippy.on('error', function copyFailed() {
      self.copyFallback();
    });
  } else {
    copyBtn.addEventListener('click', function clipboardUnsupported() {
      self.copyFallback();
    });
  }
};

SubscribeDialog.prototype.copyFallback = function legacyClickCopyButton() {
  /* eslint-disable no-alert */
  window.prompt('Copy the URL below:', this.feedUrl);
  /* eslint-enable no-alert */
};

module.exports = SubscribeDialog;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

const ThemeToggle = forgeUiComponent('ThemeToggle', null, function ThemeToggleConstructor(rootElement, options, componentBuilder) {
  const self = this;
  const darkButton = this.queryProperty('darkSwitch');
  const lightButton = this.queryProperty('lightSwitch');
  // if we're being honest the reason these props are named 'switch' not 'button' is so that 'lightSwitch' is a thing

  componentBuilder.defineClassState('darkRising', 'is-darkRising');
  componentBuilder.defineClassState('lit', 'is-lit');

  darkButton.addEventListener('click', function clickDarkButton(e) {
    e.stopPropagation();
    e.preventDefault();
    self.dispatchEvent(events.themeChange, { themeName: 'dark' }, e.target);
  });

  lightButton.addEventListener('click', function clickLightButton(e) {
    e.stopPropagation();
    e.preventDefault();
    self.dispatchEvent(events.themeChange, { themeName: 'light' }, e.target);
  });

  document.addEventListener(events.themeWasChanged, function (e) {
    self.handleThemeChange(e);
  });
});

ThemeToggle.prototype.handleThemeChange = function handleThemeChange(e) {
  const self = this;
  this.darkRising = false;
  this.lit = false;
  // HACK: Reset animation to ensure it plays again
  // https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Animations/Tips#JavaScript_content
  requestAnimationFrame(function awaitRepaint() {
    requestAnimationFrame(function resetAnimationClass() {
      switch (e.detail.themeName) {
        case 'dark':
          self.darkRising = true;
          self.lit = false;
          break;
        case 'light':
          self.darkRising = false;
          self.lit = true;
          break;
        default: break;
      }
    });
  });
};

module.exports = ThemeToggle;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);

const Themeable = forgeUiComponent('Themeable', null, function ThemeableConstructor(rootElement, options, componentBuilder) {
  const self = this;
  var styleSheetIndex;

  componentBuilder.defineClassState('switching', 'is-switching');

  Object.defineProperty(this, 'themeStyleSheets', {
    get: function getThemeStyleSheets() {
      return styleSheetIndex;
    },
    set: function setThemeStyleSheets(styleSheets) {
      styleSheetIndex = styleSheets;
    }
  });

  this.element.addEventListener(events.themeChange, function (e) {
    if (e.detail && e.detail.themeName) {
      self.switch(e.detail.themeName);
    }
  });

  // Cache the theme definition
  this.reindex();
});

Themeable.prototype.reindex = function indexThemes() {
  const stylesheets = this.element.querySelectorAll('link.Themeable-styleSheet');
  this.themeStyleSheets = Array.prototype.reduce.call(stylesheets, function groupStyleSheets(themes, stylesheet) {
    const themeName = stylesheet.getAttribute('data-theme');
    // You must set `data-theme` on appropraite stylesheets else they'll be ignored.
    if (!themeName) {
      return themes;
    }
    themes[themeName] = themes[themeName] || [];
    themes[themeName].push(stylesheet);
    return themes;
  }, {});
  return this.themeStyleSheets;
};

Themeable.prototype.disable = function disableTheme(name) {
  const themes = this.themeStyleSheets;
  (themes[name] || []).forEach(function disable(styleSheet) {
    styleSheet.disabled = true;
  });
};

/**
 * Enables a set of theme stylesheets. Note: Does not also disable other themes (use `switch`), so the natural
 * cascade kicks in.
 * @param {String} name The name of the theme to be enabled
 */
Themeable.prototype.enable = function enableTheme(name) {
  const themes = this.themeStyleSheets;
  const styleSheets = themes[name] || [];
  styleSheets.forEach(function disable(styleSheet) {
    // If <link> was included but not marked up to load with the page, set metadata now:
    if (styleSheet.rel !== 'stylesheet') {
      styleSheet.rel = 'stylesheet';
    }
    styleSheet.disabled = false;
  });
  // Return the stylesheets that are being enabled, as we may need to monitor their load status
  return styleSheets;
};

Themeable.prototype.persist = function setPersistanceCookie(name) {
  document.cookie = [
    'theme=', encodeURIComponent(name),
    ';max-age=', (60 * 60 * 24 * 365 * 10),
    ';path=/',
    ';secure'].join('');
};

/**
 * Enables the specified theme (if it exists) and disables all others. Themes are specified using `data-theme=name` on
 * the `<link>` element(s) for their stylesheets. This assumes that only one theme may be enabled at a time.
 * stylesheets without a theme name are ignored.
 * @param {String} name The name of the theme to be enabled
 */
Themeable.prototype.switch = function switchTheme(name) {
  const self = this;
  const themes = Object.keys(this.themeStyleSheets);
  if (themes.indexOf(name) < 0) {
    return;
  }
  self.switching = true;

  const newStyleSheets = this.enable(name);
  const awaitingStyleSheets = newStyleSheets.filter(function (link) { return !link.sheet; });
  const disableOthers = function disableOtherStyleSheets() {
    themes.filter(function (t) { return t !== name; }).forEach(function (themeName) {
      self.disable(themeName);
    });
    self.switching = false;
    self.dispatchEvent(events.themeWasChanged, { themeName: name });
  };

  if (awaitingStyleSheets.length === 0) {
    disableOthers();
  } else {
    awaitingStyleSheets.forEach(function handleStyleSheetLoad(link) {
      link.addEventListener('load', function styleSheetLoaded() {
        const remainingStyleSheets = newStyleSheets.filter(function (remainingLink) { return !remainingLink.sheet; });
        if (remainingStyleSheets.length === 0) {
          disableOthers();
        }
      });
    });
  }

  this.persist(name);
};

module.exports = Themeable;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

const events = __webpack_require__(0);
const forgeUiComponent = __webpack_require__(1);
const htmlPage = __webpack_require__(119);

var Totaliser = forgeUiComponent('Totaliser', null, function TotaliserConstructor(rootElement, options, componentBuilder) {
  const self = this;
  const remainingElement = this.queryProperty('targetRemaining');
  const raisedElement = this.queryProperty('totalRaised');

  var targetAmount = 0;
  var raisedAmount = 0;

  componentBuilder.defineClassState('overFunded', 'is-funded-over');
  componentBuilder.defineClassState('dataUpdated', 'is-updated');

  Object.defineProperty(this, 'amountTargetted', {
    get: function getTargetAmount() { return targetAmount; },
    set: function setTargetAmount(amount) {
      if (isNaN(amount)) {
        return;
      }
      targetAmount = amount;
    }
  });

  Object.defineProperty(this, 'amountRaised', {
    get: function getAmountRaised() { return raisedAmount; },
    set: function setAmountRaised(amount) {
      if (isNaN(amount)) {
        return;
      }
      raisedAmount = amount;
      raisedElement.textContent = '$' + amount;
    }
  });

  Object.defineProperty(this, 'amountRemaining', {
    set: function setAmountRemaining(amount) {
      if (isNaN(amount)) {
        return;
      }
      remainingElement.textContent = '$' + amount;
      this.overFunded = amount < 0;
    }
  });

  componentBuilder.defineAttributeProperty('totaliserValuesUrl', 'data-values-href', function () {
    return false;
  });

  componentBuilder.defineAttributeProperty('fundingLevel', 'data-funded', function (val) {
    if (!isNaN(val) && (val % 5 === 0)) {
      if (val > 100) {
        return 'over';
      } else {
        return val;
      }
    } else {
      return 0;
    }
  });

  document.addEventListener(events.dataHtmlPage, function (e) {
    /* Creek doesn't have a metadata API today so we're hacking data into a secret page.
     * The title will be in the format RAISED/TOTAL, and the Totaliser content updated
     * using those values */
    if (e.detail && e.detail.querySelector) {
      const fundraiserDataElement = e.detail.querySelector('.Article-title');
      const data = fundraiserDataElement.textContent || '';
      const parts = data.trim().split('/');
      self.updateValues(parts[0], parts[1]);
    }
  });

  htmlPage.fetch(this.totaliserValuesUrl);
});

Totaliser.prototype.updateValues = function updateValues(raised, target) {
  this.amountTargetted = target;
  this.amountRaised = raised;
  this.amountRemaining = target - raised;

  const perCent = (raised / target) * 100;
  const perCentRounded = Math.ceil(perCent / 5) * 5;
  this.fundingLevel = perCentRounded;

  this.dataUpdated = true;
};

module.exports = Totaliser;


/***/ }),
/* 78 */
/***/ (function(module, exports) {

/** Wrapper for widgets.js */

const TWITTER_SCRIPT_ID = 'twitter-wjs';
const TWITTER_EMBED_CODE_SELECTORS = [
  'a.twitter-share-button',
  'a.twitter-hashtag-button',
  'a.twitter-follow-button',
  'blockquote.twitter-tweet',
  'a.twitter-timeline'
].join(',');

function TwitterWidgets(root) {
  // Don't load Twitter script until we're on a page that includes widgets
  if (!root.querySelector(TWITTER_EMBED_CODE_SELECTORS)) {
    return;
  }

  /* Automatically pull in Twitter script */
  window.twttr = (function () {
    var js;
    var meta;
    var twttr = window.twttr || {};

    if (document.getElementById(TWITTER_SCRIPT_ID)) { return twttr; }

    const head = document.querySelector('head');

    meta = document.createElement('meta');
    meta.name = 'twitter:widgets:autoload';
    meta.content = 'off';

    // TODO: Pull this from a config somehow
    meta = document.createElement('meta');
    meta.name = 'twitter:widgets:link-color';
    meta.content = '#69C1BB';

    js = document.createElement('script');
    js.id = TWITTER_SCRIPT_ID;
    js.async = true;
    js.src = 'https://platform.twitter.com/widgets.js';

    head.appendChild(meta);
    head.appendChild(js);

    /* eslint-disable no-underscore-dangle */
    twttr._e = [];
    twttr.ready = function (f) { twttr._e.push(f); };
    /* eslint-enable no-underscore-dangle */

    return twttr;
  }());

  this.call(function (twttr) { twttr.widgets.load(root); });
}

TwitterWidgets.prototype.call = function callWidgets(callback) {
  window.twttr.ready(callback);
};

// Unlike other UIComponents, Twitter widgets are initialized within the element root,
// so we always return one component that may or may not contain widgets later.
TwitterWidgets.discover = function (root) {
  return {
    components: [new TwitterWidgets(root)],
    errors: []
  };
};

module.exports = TwitterWidgets;


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__transports__ = __webpack_require__(23);






/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._options.transportOptions, { dsn: this._options.dsn });
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["K" /* supportsFetch */])()) {
            return new __WEBPACK_IMPORTED_MODULE_5__transports__["FetchTransport"](transportOptions);
        }
        return new __WEBPACK_IMPORTED_MODULE_5__transports__["XHRTransport"](transportOptions);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        var syntheticException = (hint && hint.syntheticException) || undefined;
        var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["a" /* eventFromUnknownInput */])(exception, syntheticException, {
            attachStacktrace: this._options.attachStacktrace,
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["C" /* addExceptionMechanism */])(event, {
            handled: true,
            type: 'generic',
        });
        event.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error;
        if (hint && hint.event_id) {
            event.event_id = hint.event_id;
        }
        return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["b" /* SyncPromise */].resolve(event);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Info; }
        var syntheticException = (hint && hint.syntheticException) || undefined;
        var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["b" /* eventFromString */])(message, syntheticException, {
            attachStacktrace: this._options.attachStacktrace,
        });
        event.level = level;
        if (hint && hint.event_id) {
            event.event_id = hint.event_id;
        }
        return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["b" /* SyncPromise */].resolve(event);
    };
    return BrowserBackend;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["w" /* BaseBackend */]));

//# sourceMappingURL=backend.js.map

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Integrations", function() { return INTEGRATIONS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Severity", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_types__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Status", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_core__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addGlobalEventProcessor", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addBreadcrumb", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "captureException", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "captureEvent", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "captureMessage", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "configureScope", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getHubFromCarrier", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrentHub", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Hub", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scope", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setContext", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setExtra", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["l"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setExtras", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["m"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setTag", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["n"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setTags", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setUser", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["p"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Span", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["q"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withScope", function() { return __WEBPACK_IMPORTED_MODULE_2__sentry_core__["r"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__client__ = __webpack_require__(19);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserClient", function() { return __WEBPACK_IMPORTED_MODULE_3__client__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sdk__ = __webpack_require__(86);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultIntegrations", function() { return __WEBPACK_IMPORTED_MODULE_4__sdk__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "forceLoad", function() { return __WEBPACK_IMPORTED_MODULE_4__sdk__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return __WEBPACK_IMPORTED_MODULE_4__sdk__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lastEventId", function() { return __WEBPACK_IMPORTED_MODULE_4__sdk__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "onLoad", function() { return __WEBPACK_IMPORTED_MODULE_4__sdk__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "showReportDialog", function() { return __WEBPACK_IMPORTED_MODULE_4__sdk__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return __WEBPACK_IMPORTED_MODULE_4__sdk__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "close", function() { return __WEBPACK_IMPORTED_MODULE_4__sdk__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "wrap", function() { return __WEBPACK_IMPORTED_MODULE_4__sdk__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version__ = __webpack_require__(24);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SDK_NAME", function() { return __WEBPACK_IMPORTED_MODULE_5__version__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SDK_VERSION", function() { return __WEBPACK_IMPORTED_MODULE_5__version__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__integrations__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transports__ = __webpack_require__(23);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "Transports", function() { return __WEBPACK_IMPORTED_MODULE_8__transports__; });










var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
// tslint:disable: no-unsafe-any
var _window = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__sentry_utils__["a" /* getGlobalObject */])();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
// tslint:enable: no-unsafe-any
var INTEGRATIONS = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, windowIntegrations, __WEBPACK_IMPORTED_MODULE_2__sentry_core__["s" /* Integrations */], __WEBPACK_IMPORTED_MODULE_7__integrations__);

//# sourceMappingURL=index.js.map

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumbs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(11);





var global = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["a" /* getGlobalObject */])();
var lastHref;
/** Default Breadcrumbs instrumentations */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /** JSDoc */
    Breadcrumbs.prototype._instrumentConsole = function () {
        if (!('console' in global)) {
            return;
        }
        ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
            if (!(level in global.console)) {
                return;
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* fill */])(global.console, level, function (originalConsoleLevel) {
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var breadcrumbData = {
                        category: 'console',
                        data: {
                            extra: {
                                arguments: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["r" /* normalize */])(args, 3),
                            },
                            logger: 'console',
                        },
                        level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].fromString(level),
                        message: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["w" /* safeJoin */])(args, ' '),
                    };
                    if (level === 'assert') {
                        if (args[0] === false) {
                            breadcrumbData.message = "Assertion failed: " + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["w" /* safeJoin */])(args.slice(1), ' ') || 'console.assert');
                            breadcrumbData.data.extra.arguments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["r" /* normalize */])(args.slice(1), 3);
                            Breadcrumbs.addBreadcrumb(breadcrumbData, {
                                input: args,
                                level: level,
                            });
                        }
                    }
                    else {
                        Breadcrumbs.addBreadcrumb(breadcrumbData, {
                            input: args,
                            level: level,
                        });
                    }
                    // this fails for some browsers. :(
                    if (originalConsoleLevel) {
                        Function.prototype.apply.call(originalConsoleLevel, global.console, args);
                    }
                };
            });
        });
    };
    /** JSDoc */
    Breadcrumbs.prototype._instrumentDOM = function () {
        if (!('document' in global)) {
            return;
        }
        // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
        // to the document. Do this before we instrument addEventListener.
        global.document.addEventListener('click', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* breadcrumbEventHandler */])('click'), false);
        global.document.addEventListener('keypress', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* keypressEventHandler */])(), false);
        // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
        ['EventTarget', 'Node'].forEach(function (target) {
            var proto = global[target] && global[target].prototype;
            if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
                return;
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* fill */])(proto, 'addEventListener', function (original) {
                return function (eventName, fn, options) {
                    if (fn && fn.handleEvent) {
                        if (eventName === 'click') {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                                return function (event) {
                                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* breadcrumbEventHandler */])('click')(event);
                                    return innerOriginal.call(this, event);
                                };
                            });
                        }
                        if (eventName === 'keypress') {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                                return function (event) {
                                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* keypressEventHandler */])()(event);
                                    return innerOriginal.call(this, event);
                                };
                            });
                        }
                    }
                    else {
                        if (eventName === 'click') {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* breadcrumbEventHandler */])('click', true)(this);
                        }
                        if (eventName === 'keypress') {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* keypressEventHandler */])()(this);
                        }
                    }
                    return original.call(this, eventName, fn, options);
                };
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* fill */])(proto, 'removeEventListener', function (original) {
                return function (eventName, fn, options) {
                    var callback = fn;
                    try {
                        callback = callback && (callback.__sentry_wrapped__ || callback);
                    }
                    catch (e) {
                        // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                    }
                    return original.call(this, eventName, callback, options);
                };
            });
        });
    };
    /** JSDoc */
    Breadcrumbs.prototype._instrumentFetch = function () {
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["x" /* supportsNativeFetch */])()) {
            return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* fill */])(global, 'fetch', function (originalFetch) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var fetchInput = args[0];
                var method = 'GET';
                var url;
                if (typeof fetchInput === 'string') {
                    url = fetchInput;
                }
                else if ('Request' in global && fetchInput instanceof Request) {
                    url = fetchInput.url;
                    if (fetchInput.method) {
                        method = fetchInput.method;
                    }
                }
                else {
                    url = String(fetchInput);
                }
                if (args[1] && args[1].method) {
                    method = args[1].method;
                }
                var client = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getClient();
                var dsn = client && client.getDsn();
                if (dsn) {
                    var filterUrl = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["t" /* API */](dsn).getStoreEndpoint();
                    // if Sentry key appears in URL, don't capture it as a request
                    // but rather as our own 'sentry' type breadcrumb
                    if (filterUrl && url.indexOf(filterUrl) !== -1) {
                        if (method === 'POST' && args[1] && args[1].body) {
                            addSentryBreadcrumb(args[1].body);
                        }
                        return originalFetch.apply(global, args);
                    }
                }
                var fetchData = {
                    method: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["y" /* isString */])(method) ? method.toUpperCase() : method,
                    url: url,
                };
                return originalFetch
                    .apply(global, args)
                    .then(function (response) {
                    fetchData.status_code = response.status;
                    Breadcrumbs.addBreadcrumb({
                        category: 'fetch',
                        data: fetchData,
                        type: 'http',
                    }, {
                        input: args,
                        response: response,
                    });
                    return response;
                })
                    .then(null, function (error) {
                    Breadcrumbs.addBreadcrumb({
                        category: 'fetch',
                        data: fetchData,
                        level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error,
                        type: 'http',
                    }, {
                        error: error,
                        input: args,
                    });
                    throw error;
                });
            };
        });
    };
    /** JSDoc */
    Breadcrumbs.prototype._instrumentHistory = function () {
        var _this = this;
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["z" /* supportsHistory */])()) {
            return;
        }
        var captureUrlChange = function (from, to) {
            var parsedLoc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["A" /* parseUrl */])(global.location.href);
            var parsedTo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["A" /* parseUrl */])(to);
            var parsedFrom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["A" /* parseUrl */])(from);
            // Initial pushState doesn't provide `from` information
            if (!parsedFrom.path) {
                parsedFrom = parsedLoc;
            }
            // because onpopstate only tells you the "new" (to) value of location.href, and
            // not the previous (from) value, we need to track the value of the current URL
            // state ourselves
            lastHref = to;
            // Use only the path component of the URL if the URL matches the current
            // document (almost all the time when using pushState)
            if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
                // tslint:disable-next-line:no-parameter-reassignment
                to = parsedTo.relative;
            }
            if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
                // tslint:disable-next-line:no-parameter-reassignment
                from = parsedFrom.relative;
            }
            Breadcrumbs.addBreadcrumb({
                category: 'navigation',
                data: {
                    from: from,
                    to: to,
                },
            });
        };
        // record navigation (URL) changes
        var oldOnPopState = global.onpopstate;
        global.onpopstate = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var currentHref = global.location.href;
            captureUrlChange(lastHref, currentHref);
            if (oldOnPopState) {
                return oldOnPopState.apply(_this, args);
            }
        };
        /**
         * @hidden
         */
        function historyReplacementFunction(originalHistoryFunction) {
            // note history.pushState.length is 0; intentionally not declaring
            // params to preserve 0 arity
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var url = args.length > 2 ? args[2] : undefined;
                // url argument is optional
                if (url) {
                    // coerce to string (this is what pushState does)
                    captureUrlChange(lastHref, String(url));
                }
                return originalHistoryFunction.apply(this, args);
            };
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* fill */])(global.history, 'pushState', historyReplacementFunction);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* fill */])(global.history, 'replaceState', historyReplacementFunction);
    };
    /** JSDoc */
    Breadcrumbs.prototype._instrumentXHR = function () {
        if (!('XMLHttpRequest' in global)) {
            return;
        }
        /**
         * @hidden
         */
        function wrapProp(prop, xhr) {
            if (prop in xhr && typeof xhr[prop] === 'function') {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* fill */])(xhr, prop, function (original) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["c" /* wrap */])(original, {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: (original && original.name) || '<anonymous>',
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    });
                });
            }
        }
        var xhrproto = XMLHttpRequest.prototype;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* fill */])(xhrproto, 'open', function (originalOpen) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var url = args[1];
                this.__sentry_xhr__ = {
                    method: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["y" /* isString */])(args[0]) ? args[0].toUpperCase() : args[0],
                    url: args[1],
                };
                var client = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getClient();
                var dsn = client && client.getDsn();
                if (dsn) {
                    var filterUrl = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["t" /* API */](dsn).getStoreEndpoint();
                    // if Sentry key appears in URL, don't capture it as a request
                    // but rather as our own 'sentry' type breadcrumb
                    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["y" /* isString */])(url) && (filterUrl && url.indexOf(filterUrl) !== -1)) {
                        this.__sentry_own_request__ = true;
                    }
                }
                return originalOpen.apply(this, args);
            };
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* fill */])(xhrproto, 'send', function (originalSend) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var xhr = this; // tslint:disable-line:no-this-assignment
                if (xhr.__sentry_own_request__) {
                    addSentryBreadcrumb(args[0]);
                }
                /**
                 * @hidden
                 */
                function onreadystatechangeHandler() {
                    if (xhr.readyState === 4) {
                        if (xhr.__sentry_own_request__) {
                            return;
                        }
                        try {
                            // touching statusCode in some platforms throws
                            // an exception
                            if (xhr.__sentry_xhr__) {
                                xhr.__sentry_xhr__.status_code = xhr.status;
                            }
                        }
                        catch (e) {
                            /* do nothing */
                        }
                        Breadcrumbs.addBreadcrumb({
                            category: 'xhr',
                            data: xhr.__sentry_xhr__,
                            type: 'http',
                        }, {
                            xhr: xhr,
                        });
                    }
                }
                var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress'];
                xmlHttpRequestProps.forEach(function (prop) {
                    wrapProp(prop, xhr);
                });
                if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* fill */])(xhr, 'onreadystatechange', function (original) {
                        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__helpers__["c" /* wrap */])(original, {
                            mechanism: {
                                data: {
                                    function: 'onreadystatechange',
                                    handler: (original && original.name) || '<anonymous>',
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        }, onreadystatechangeHandler);
                    });
                }
                else {
                    // if onreadystatechange wasn't actually set by the page on this xhr, we
                    // are free to set our own and capture the breadcrumb
                    xhr.onreadystatechange = onreadystatechangeHandler;
                }
                return originalSend.apply(this, args);
            };
        });
    };
    /**
     * Helper that checks if integration is enabled on the client.
     * @param breadcrumb Breadcrumb
     * @param hint BreadcrumbHint
     */
    Breadcrumbs.addBreadcrumb = function (breadcrumb, hint) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getIntegration(Breadcrumbs)) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().addBreadcrumb(breadcrumb, hint);
        }
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        if (this._options.console) {
            this._instrumentConsole();
        }
        if (this._options.dom) {
            this._instrumentDOM();
        }
        if (this._options.xhr) {
            this._instrumentXHR();
        }
        if (this._options.fetch) {
            this._instrumentFetch();
        }
        if (this._options.history) {
            this._instrumentHistory();
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

/** JSDoc */
function addSentryBreadcrumb(serializedData) {
    // There's always something that can go wrong with deserialization...
    try {
        var event_1 = JSON.parse(serializedData);
        Breadcrumbs.addBreadcrumb({
            category: 'sentry',
            event_id: event_1.event_id,
            level: event_1.level || __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].fromString('error'),
            message: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["h" /* getEventDescription */])(event_1),
        }, {
            event: event_1,
        });
    }
    catch (_oO) {
        __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* logger */].error('Error while adding sentry type breadcrumb');
    }
}
//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalHandlers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventbuilder__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers__ = __webpack_require__(11);






/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /** JSDoc */
        this._global = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["a" /* getGlobalObject */])();
        /** JSDoc */
        this._oldOnErrorHandler = null;
        /** JSDoc */
        this._oldOnUnhandledRejectionHandler = null;
        /** JSDoc */
        this._onErrorHandlerInstalled = false;
        /** JSDoc */
        this._onUnhandledRejectionHandlerInstalled = false;
        this._options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        if (this._options.onerror) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* logger */].log('Global Handler attached: onerror');
            this._installGlobalOnErrorHandler();
        }
        if (this._options.onunhandledrejection) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* logger */].log('Global Handler attached: onunhandledrejection');
            this._installGlobalOnUnhandledRejectionHandler();
        }
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnErrorHandler = function () {
        if (this._onErrorHandlerInstalled) {
            return;
        }
        var self = this; // tslint:disable-line:no-this-assignment
        this._oldOnErrorHandler = this._global.onerror;
        this._global.onerror = function (msg, url, line, column, error) {
            var currentHub = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])();
            var hasIntegration = currentHub.getIntegration(GlobalHandlers);
            var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
            if (!hasIntegration || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["d" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                if (self._oldOnErrorHandler) {
                    return self._oldOnErrorHandler.apply(this, arguments);
                }
                return true;
            }
            var client = currentHub.getClient();
            var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["j" /* isPrimitive */])(error)
                ? self._eventFromIncompleteOnError(msg, url, line, column)
                : self._enhanceEventWithInitialFrame(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["a" /* eventFromUnknownInput */])(error, undefined, {
                    attachStacktrace: client && client.getOptions().attachStacktrace,
                    rejection: false,
                }), url, line, column);
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["C" /* addExceptionMechanism */])(event, {
                handled: false,
                type: 'onerror',
            });
            currentHub.captureEvent(event, {
                originalException: error,
            });
            if (self._oldOnErrorHandler) {
                return self._oldOnErrorHandler.apply(this, arguments);
            }
            return true;
        };
        this._onErrorHandlerInstalled = true;
    };
    /** JSDoc */
    GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function () {
        if (this._onUnhandledRejectionHandlerInstalled) {
            return;
        }
        var self = this; // tslint:disable-line:no-this-assignment
        this._oldOnUnhandledRejectionHandler = this._global.onunhandledrejection;
        this._global.onunhandledrejection = function (e) {
            var error = e;
            try {
                error = e && 'reason' in e ? e.reason : e;
            }
            catch (_oO) {
                // no-empty
            }
            var currentHub = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])();
            var hasIntegration = currentHub.getIntegration(GlobalHandlers);
            var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
            if (!hasIntegration || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers__["d" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                if (self._oldOnUnhandledRejectionHandler) {
                    return self._oldOnUnhandledRejectionHandler.apply(this, arguments);
                }
                return true;
            }
            var client = currentHub.getClient();
            var event = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["j" /* isPrimitive */])(error)
                ? self._eventFromIncompleteRejection(error)
                : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__eventbuilder__["a" /* eventFromUnknownInput */])(error, undefined, {
                    attachStacktrace: client && client.getOptions().attachStacktrace,
                    rejection: true,
                });
            event.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error;
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["C" /* addExceptionMechanism */])(event, {
                handled: false,
                type: 'onunhandledrejection',
            });
            currentHub.captureEvent(event, {
                originalException: error,
            });
            if (self._oldOnUnhandledRejectionHandler) {
                return self._oldOnUnhandledRejectionHandler.apply(this, arguments);
            }
            return true;
        };
        this._onUnhandledRejectionHandlerInstalled = true;
    };
    /**
     * This function creates a stack from an old, error-less onerror handler.
     */
    GlobalHandlers.prototype._eventFromIncompleteOnError = function (msg, url, line, column) {
        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
        // If 'message' is ErrorEvent, get real message from inside
        var message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["E" /* isErrorEvent */])(msg) ? msg.message : msg;
        var name;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["y" /* isString */])(message)) {
            var groups = message.match(ERROR_TYPES_RE);
            if (groups) {
                name = groups[1];
                message = groups[2];
            }
        }
        var event = {
            exception: {
                values: [
                    {
                        type: name || 'Error',
                        value: message,
                    },
                ],
            },
        };
        return this._enhanceEventWithInitialFrame(event, url, line, column);
    };
    /**
     * This function creates an Event from an TraceKitStackTrace that has part of it missing.
     */
    GlobalHandlers.prototype._eventFromIncompleteRejection = function (error) {
        return {
            exception: {
                values: [
                    {
                        type: 'UnhandledRejection',
                        value: "Non-Error promise rejection captured with value: " + error,
                    },
                ],
            },
        };
    };
    /** JSDoc */
    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function (event, url, line, column) {
        event.exception = event.exception || {};
        event.exception.values = event.exception.values || [];
        event.exception.values[0] = event.exception.values[0] || {};
        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
        var filename = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["y" /* isString */])(url) && url.length > 0 ? url : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["F" /* getLocationHref */])();
        if (event.exception.values[0].stacktrace.frames.length === 0) {
            event.exception.values[0].stacktrace.frames.push({
                colno: colno,
                filename: filename,
                function: '?',
                in_app: true,
                lineno: lineno,
            });
        }
        return event;
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsers__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracekit__ = __webpack_require__(15);




var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* addGlobalEventProcessor */])(function (event, hint) {
            var self = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getIntegration(LinkedErrors);
            if (self) {
                return self._handler(event, hint);
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._handler = function (event, hint) {
        if (!event.exception || !event.exception.values || !hint || !(hint.originalException instanceof Error)) {
            return event;
        }
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
        if (stack === void 0) { stack = []; }
        if (!(error[key] instanceof Error) || stack.length + 1 >= this._limit) {
            return stack;
        }
        var stacktrace = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tracekit__["a" /* computeStackTrace */])(error[key]);
        var exception = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__parsers__["a" /* exceptionFromStacktrace */])(stacktrace);
        return this._walkErrorTree(error[key], key, __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */]([exception], stack));
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TryCatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(11);


/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    function TryCatch() {
        /** JSDoc */
        this._ignoreOnError = 0;
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
    }
    /** JSDoc */
    TryCatch.prototype._wrapTimeFunction = function (original) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var originalCallback = args[0];
            args[0] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* wrap */])(originalCallback, {
                mechanism: {
                    data: { function: getFunctionName(original) },
                    handled: true,
                    type: 'instrument',
                },
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapRAF = function (original) {
        return function (callback) {
            return original(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* wrap */])(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: getFunctionName(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }));
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapEventTarget = function (target) {
        var global = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["a" /* getGlobalObject */])();
        var proto = global[target] && global[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["v" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    // tslint:disable-next-line:no-unbound-method strict-type-predicates
                    if (typeof fn.handleEvent === 'function') {
                        fn.handleEvent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* wrap */])(fn.handleEvent.bind(fn), {
                            mechanism: {
                                data: {
                                    function: 'handleEvent',
                                    handler: getFunctionName(fn),
                                    target: target,
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        });
                    }
                }
                catch (err) {
                    // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helpers__["c" /* wrap */])(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: getFunctionName(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }), options);
            };
        });
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["v" /* fill */])(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                var callback = fn;
                try {
                    callback = callback && (callback.__sentry_wrapped__ || callback);
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, callback, options);
            };
        });
    };
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        this._ignoreOnError = this._ignoreOnError;
        var global = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["a" /* getGlobalObject */])();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["v" /* fill */])(global, 'setTimeout', this._wrapTimeFunction.bind(this));
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["v" /* fill */])(global, 'setInterval', this._wrapTimeFunction.bind(this));
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["v" /* fill */])(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
        [
            'EventTarget',
            'Window',
            'Node',
            'ApplicationCache',
            'AudioTrackList',
            'ChannelMergerNode',
            'CryptoOperation',
            'EventSource',
            'FileReader',
            'HTMLUnknownElement',
            'IDBDatabase',
            'IDBRequest',
            'IDBTransaction',
            'KeyOperation',
            'MediaController',
            'MessagePort',
            'ModalWindow',
            'Notification',
            'SVGElementInstance',
            'Screen',
            'TextTrack',
            'TextTrackCue',
            'TextTrackList',
            'WebSocket',
            'WebSocketWorker',
            'Worker',
            'XMLHttpRequest',
            'XMLHttpRequestEventTarget',
            'XMLHttpRequestUpload',
        ].forEach(this._wrapEventTarget.bind(this));
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        return (fn && fn.name) || '<anonymous>';
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return '<anonymous>';
    }
}
//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserAgent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);



var global = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["a" /* getGlobalObject */])();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* addGlobalEventProcessor */])(function (event) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["h" /* getCurrentHub */])().getIntegration(UserAgent)) {
                if (!global.navigator || !global.location) {
                    return event;
                }
                // Request Interface: https://docs.sentry.io/development/sdk-dev/event-payloads/request/
                var request = event.request || {};
                request.url = request.url || global.location.href;
                request.headers = request.headers || {};
                request.headers['User-Agent'] = global.navigator.userAgent;
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event, { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultIntegrations; });
/* harmony export (immutable) */ __webpack_exports__["c"] = init;
/* harmony export (immutable) */ __webpack_exports__["f"] = showReportDialog;
/* harmony export (immutable) */ __webpack_exports__["d"] = lastEventId;
/* harmony export (immutable) */ __webpack_exports__["b"] = forceLoad;
/* harmony export (immutable) */ __webpack_exports__["e"] = onLoad;
/* harmony export (immutable) */ __webpack_exports__["g"] = flush;
/* harmony export (immutable) */ __webpack_exports__["h"] = close;
/* harmony export (immutable) */ __webpack_exports__["i"] = wrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(21);





var defaultIntegrations = [
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["s" /* Integrations */].InboundFilters(),
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["s" /* Integrations */].FunctionToString(),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["TryCatch"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["Breadcrumbs"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["GlobalHandlers"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["LinkedErrors"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["UserAgent"](),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["a" /* getGlobalObject */])();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["u" /* initAndBind */])(__WEBPACK_IMPORTED_MODULE_2__client__["a" /* BrowserClient */], options);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        options.eventId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().lastEventId();
    }
    var client = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function flush(timeout) {
    var client = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().getClient();
    if (client) {
        return client.flush(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SyncPromise */].reject(false);
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function close(timeout) {
    var client = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* getCurrentHub */])().getClient();
    if (client) {
        return client.close(timeout);
    }
    return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SyncPromise */].reject(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
function wrap(fn) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__helpers__["c" /* wrap */])(fn)(); // tslint:disable-line:no-unsafe-any
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(16);




var global = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["a" /* getGlobalObject */])();
/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](FetchTransport, _super);
    function FetchTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Locks transport after receiving 429 response */
        _this._disabledUntil = new Date(Date.now());
        return _this;
    }
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendEvent = function (event) {
        var _this = this;
        if (new Date(Date.now()) < this._disabledUntil) {
            return Promise.reject({
                event: event,
                reason: "Transport locked till " + this._disabledUntil + " due to too many requests.",
                status: 429,
            });
        }
        var defaultOptions = {
            body: JSON.stringify(event),
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
            // https://caniuse.com/#feat=referrer-policy
            // It doesn't. And it throw exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["e" /* supportsReferrerPolicy */])() ? 'origin' : ''),
        };
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["b" /* SyncPromise */](function (resolve, reject) {
            global
                .fetch(_this.url, defaultOptions)
                .then(function (response) {
                var status = __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].fromHttpCode(response.status);
                if (status === __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].Success) {
                    resolve({ status: status });
                    return;
                }
                if (status === __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].RateLimit) {
                    var now = Date.now();
                    _this._disabledUntil = new Date(now + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["c" /* parseRetryAfterHeader */])(now, response.headers.get('Retry-After')));
                    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* logger */].warn("Too many requests, backing off till: " + _this._disabledUntil);
                }
                reject(response);
            })
                .catch(reject);
        }));
    };
    return FetchTransport;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseTransport */]));

//# sourceMappingURL=fetch.js.map

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return XHRTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(16);




/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](XHRTransport, _super);
    function XHRTransport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** Locks transport after receiving 429 response */
        _this._disabledUntil = new Date(Date.now());
        return _this;
    }
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendEvent = function (event) {
        var _this = this;
        if (new Date(Date.now()) < this._disabledUntil) {
            return Promise.reject({
                event: event,
                reason: "Transport locked till " + this._disabledUntil + " due to too many requests.",
                status: 429,
            });
        }
        return this._buffer.add(new __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["b" /* SyncPromise */](function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState !== 4) {
                    return;
                }
                var status = __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].fromHttpCode(request.status);
                if (status === __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].Success) {
                    resolve({ status: status });
                    return;
                }
                if (status === __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].RateLimit) {
                    var now = Date.now();
                    _this._disabledUntil = new Date(now + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["c" /* parseRetryAfterHeader */])(now, request.getResponseHeader('Retry-After')));
                    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* logger */].warn("Too many requests, backing off till: " + _this._disabledUntil);
                }
                reject(request);
            };
            request.open('POST', _this.url);
            request.send(JSON.stringify(event));
        }));
    };
    return XHRTransport;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseTransport */]));

//# sourceMappingURL=xhr.js.map

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dsn__ = __webpack_require__(17);


var SENTRY_API_VERSION = '7';
/** Helper class to provide urls to different Sentry endpoints. */
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn) {
        this.dsn = dsn;
        this._dsnObject = new __WEBPACK_IMPORTED_MODULE_1__dsn__["a" /* Dsn */](dsn);
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Returns a string with auth headers in the url to the store endpoint. */
    API.prototype.getStoreEndpoint = function () {
        return "" + this._getBaseUrl() + this.getStoreEndpointPath();
    };
    /** Returns the store endpoint with auth added in url encoded. */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        var dsn = this._dsnObject;
        var auth = {
            sentry_key: dsn.user,
            sentry_version: SENTRY_API_VERSION,
        };
        // Auth is intentionally sent as part of query string (NOT as custom HTTP header)
        // to avoid preflight CORS requests
        return this.getStoreEndpoint() + "?" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["n" /* urlEncode */])(auth);
    };
    /** Returns the base path of the url including the port. */
    API.prototype._getBaseUrl = function () {
        var dsn = this._dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port;
    };
    /** Returns only the path component for the store endpoint. */
    API.prototype.getStoreEndpointPath = function () {
        var dsn = this._dsnObject;
        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
    };
    /** Returns an object that can be used in request headers. */
    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
        var dsn = this._dsnObject;
        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
        header.push("sentry_timestamp=" + new Date().getTime());
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.user);
        if (dsn.pass) {
            header.push("sentry_secret=" + dsn.pass);
        }
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', '),
        };
    };
    /** Returns the url to the report dialog endpoint. */
    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
        if (dialogOptions === void 0) { dialogOptions = {}; }
        var dsn = this._dsnObject;
        var endpoint = "" + this._getBaseUrl() + (dsn.path ? "/" + dsn.path : '') + "/api/embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for (var key in dialogOptions) {
            if (key === 'user') {
                if (!dialogOptions.user) {
                    continue;
                }
                if (dialogOptions.user.name) {
                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
                }
                if (dialogOptions.user.email) {
                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
                }
            }
            else {
                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
            }
        }
        if (encodedOptions.length) {
            return endpoint + "?" + encodedOptions.join('&');
        }
        return endpoint;
    };
    return API;
}());

//# sourceMappingURL=api.js.map

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transports_noop__ = __webpack_require__(25);


/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["d" /* logger */].warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new __WEBPACK_IMPORTED_MODULE_1__transports_noop__["a" /* NoopTransport */]();
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["g" /* SentryError */]('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["g" /* SentryError */]('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        this._transport.sendEvent(event).then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["d" /* logger */].error("Error while sending event: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    return BaseBackend;
}());

//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dsn__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__integration__ = __webpack_require__(92);




/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient.prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Is the client still processing a call? */
        this._processing = false;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = new __WEBPACK_IMPORTED_MODULE_2__dsn__["a" /* Dsn */](options.dsn);
        }
        if (this._isEnabled()) {
            this._integrations = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__integration__["a" /* setupIntegrations */])(this._options);
        }
    }
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._processEvent(event, hint, scope); })
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        var promisedEvent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["j" /* isPrimitive */])(message)
            ? this._getBackend().eventFromMessage("" + message, level, hint)
            : this._getBackend().eventFromException(message, hint);
        promisedEvent
            .then(function (event) { return _this._processEvent(event, hint, scope); })
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._processEvent(event, hint, scope)
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .then(null, function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientProcessing(timeout).then(function (status) {
            clearInterval(status.interval);
            return _this._getBackend()
                .getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return status.ready && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegrations = function () {
        return this._integrations || {};
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Waits for the client to be done with processing. */
    BaseClient.prototype._isClientProcessing = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SyncPromise */](function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = 0;
            clearInterval(interval);
            interval = setInterval(function () {
                if (!_this._processing) {
                    resolve({
                        interval: interval,
                        ready: true,
                    });
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        resolve({
                            interval: interval,
                            ready: false,
                        });
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional informartion about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _a = this.getOptions(), environment = _a.environment, release = _a.release, dist = _a.dist, _b = _a.maxValueLength, maxValueLength = _b === void 0 ? 250 : _b;
        var prepared = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event);
        if (prepared.environment === undefined && environment !== undefined) {
            prepared.environment = environment;
        }
        if (prepared.release === undefined && release !== undefined) {
            prepared.release = release;
        }
        if (prepared.dist === undefined && dist !== undefined) {
            prepared.dist = dist;
        }
        if (prepared.message) {
            prepared.message = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["k" /* truncate */])(prepared.message, maxValueLength);
        }
        var exception = prepared.exception && prepared.exception.values && prepared.exception.values[0];
        if (exception && exception.value) {
            exception.value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["k" /* truncate */])(exception.value, maxValueLength);
        }
        var request = prepared.request;
        if (request && request.url) {
            request.url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["k" /* truncate */])(request.url, maxValueLength);
        }
        if (prepared.event_id === undefined) {
            prepared.event_id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* uuid4 */])();
        }
        this._addIntegrations(prepared.sdk);
        // We prepare the result here with a resolved Event.
        var result = __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SyncPromise */].resolve(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (scope) {
            // In case we have a hub we reassign it.
            result = scope.applyToEvent(prepared, hint);
        }
        return result;
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
     */
    BaseClient.prototype._addIntegrations = function (sdkInfo) {
        var integrationsArray = Object.keys(this._integrations);
        if (sdkInfo && integrationsArray.length > 0) {
            sdkInfo.integrations = integrationsArray;
        }
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional informartion about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        if (!this._isEnabled()) {
            return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SyncPromise */].reject('SDK not enabled, will not send event.');
        }
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        if (typeof sampleRate === 'number' && Math.random() > sampleRate) {
            return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SyncPromise */].reject('This event has been sampled, will not send event.');
        }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SyncPromise */](function (resolve, reject) {
            _this._prepareEvent(event, scope, hint)
                .then(function (prepared) {
                if (prepared === null) {
                    reject('An event processor returned null, will not send event.');
                    return;
                }
                var finalEvent = prepared;
                try {
                    var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
                    if (isInternalException || !beforeSend) {
                        _this._getBackend().sendEvent(finalEvent);
                        resolve(finalEvent);
                        return;
                    }
                    var beforeSendResult = beforeSend(prepared, hint);
                    // tslint:disable-next-line:strict-type-predicates
                    if (typeof beforeSendResult === 'undefined') {
                        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* logger */].error('`beforeSend` method has to return `null` or a valid event.');
                    }
                    else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* isThenable */])(beforeSendResult)) {
                        _this._handleAsyncBeforeSend(beforeSendResult, resolve, reject);
                    }
                    else {
                        finalEvent = beforeSendResult;
                        if (finalEvent === null) {
                            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* logger */].log('`beforeSend` returned `null`, will not send event.');
                            resolve(null);
                            return;
                        }
                        // From here on we are really async
                        _this._getBackend().sendEvent(finalEvent);
                        resolve(finalEvent);
                    }
                }
                catch (exception) {
                    _this.captureException(exception, {
                        data: {
                            __sentry__: true,
                        },
                        originalException: exception,
                    });
                    reject('`beforeSend` threw an error, will not send event.');
                }
            })
                .then(null, function () {
                reject('`beforeSend` threw an error, will not send event.');
            });
        });
    };
    /**
     * Resolves before send Promise and calls resolve/reject on parent SyncPromise.
     */
    BaseClient.prototype._handleAsyncBeforeSend = function (beforeSend, resolve, reject) {
        var _this = this;
        beforeSend
            .then(function (processedEvent) {
            if (processedEvent === null) {
                reject('`beforeSend` returned `null`, will not send event.');
                return;
            }
            // From here on we are really async
            _this._getBackend().sendEvent(processedEvent);
            resolve(processedEvent);
        })
            .then(null, function (e) {
            reject("beforeSend rejected with " + e);
        });
    };
    return BaseClient;
}());

//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export installedIntegrations */
/* unused harmony export getIntegrationsToSetup */
/* unused harmony export setupIntegration */
/* harmony export (immutable) */ __webpack_exports__["a"] = setupIntegrations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);



var installedIntegrations = [];
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = [];
    if (Array.isArray(userIntegrations)) {
        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
        var pickedIntegrationsNames_1 = [];
        // Leave only unique default integrations, that were not overridden with provided user integrations
        defaultIntegrations.forEach(function (defaultIntegration) {
            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
                integrations.push(defaultIntegration);
                pickedIntegrationsNames_1.push(defaultIntegration.name);
            }
        });
        // Don't add same user integration twice
        userIntegrations.forEach(function (userIntegration) {
            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
                integrations.push(userIntegration);
                pickedIntegrationsNames_1.push(userIntegration.name);
            }
        });
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    else {
        integrations = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](defaultIntegrations);
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a" /* addGlobalEventProcessor */], __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */]);
    installedIntegrations.push(integration.name);
    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* logger */].log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    return integrations;
}
//# sourceMappingURL=integration.js.map

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FunctionToString; });
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        originalFunctionToString = Function.prototype.toString;
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = this.__sentry__ ? this.__sentry_original__ : this;
            // tslint:disable-next-line:no-unsafe-any
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InboundFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(2);



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a" /* addGlobalEventProcessor */])(function (event) {
            var hub = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */])();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                var options = self._mergeOptions(clientOptions);
                if (self._shouldDropEvent(event, options)) {
                    return null;
                }
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* logger */].warn("Event dropped due to being internal Sentry Error.\nEvent: " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* logger */].warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event));
            return true;
        }
        if (this._isBlacklistedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* logger */].warn("Event dropped due to being matched by `blacklistUrls` option.\nEvent: " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isWhitelistedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* logger */].warn("Event dropped due to not being matched by `whitelistUrls` option.\nEvent: " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (options === void 0) { options = {}; }
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            return ((event &&
                event.exception &&
                event.exception.values &&
                event.exception.values[0] &&
                event.exception.values[0].type === 'SentryError') ||
                false);
        }
        catch (_oO) {
            return false;
        }
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (options === void 0) { options = {}; }
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["i" /* isMatchingPattern */])(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isBlacklistedUrl = function (event, options) {
        if (options === void 0) { options = {}; }
        // TODO: Use Glob instead?
        if (!options.blacklistUrls || !options.blacklistUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.blacklistUrls.some(function (pattern) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["i" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._isWhitelistedUrl = function (event, options) {
        if (options === void 0) { options = {}; }
        // TODO: Use Glob instead?
        if (!options.whitelistUrls || !options.whitelistUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.whitelistUrls.some(function (pattern) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["i" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        return {
            blacklistUrls: __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */]((this._options.blacklistUrls || []), (clientOptions.blacklistUrls || [])),
            ignoreErrors: __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */]((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
            whitelistUrls: __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */]((this._options.whitelistUrls || []), (clientOptions.whitelistUrls || [])),
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* logger */].error("Cannot extract message for event " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event));
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                var frames_1 = event.stacktrace.frames;
                return (frames_1 && frames_1[frames_1.length - 1].filename) || null;
            }
            if (event.exception) {
                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
                return (frames_2 && frames_2[frames_2.length - 1].filename) || null;
            }
            return null;
        }
        catch (oO) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* logger */].error("Cannot extract url for event " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functiontostring__ = __webpack_require__(93);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionToString", function() { return __WEBPACK_IMPORTED_MODULE_0__functiontostring__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inboundfilters__ = __webpack_require__(94);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InboundFilters", function() { return __WEBPACK_IMPORTED_MODULE_1__inboundfilters__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initAndBind;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_hub__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);


/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instanciate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* logger */].enable();
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sentry_hub__["b" /* getCurrentHub */])().bindClient(new clientClass(options));
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export API_VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Hub; });
/* unused harmony export getMainCarrier */
/* unused harmony export makeMain */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurrentHub;
/* harmony export (immutable) */ __webpack_exports__["b"] = getHubFromCarrier;
/* unused harmony export setHubOnCarrier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scope__ = __webpack_require__(26);



/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be incresed when the global interface
 * changes a and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 30;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new __WEBPACK_IMPORTED_MODULE_2__scope__["b" /* Scope */](); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [];
        this._stack.push({ client: client, scope: scope });
    }
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var top = this.getStackTop();
        if (top && top.client && top.client[method]) {
            (_a = top.client)[method].apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](args, [top.scope]));
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var stack = this.getStack();
        var parentScope = stack.length > 0 ? stack[stack.length - 1].scope : undefined;
        var scope = __WEBPACK_IMPORTED_MODULE_2__scope__["b" /* Scope */].clone(parentScope);
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        return this.getStack().pop() !== undefined;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalHint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalHint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = (this._lastEventId = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* uuid4 */])());
        this._invokeClient('captureEvent', event, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, hint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var top = this.getStackTop();
        if (!top.scope || !top.client) {
            return;
        }
        var _a = (top.client.getOptions && top.client.getOptions()) || {}, _b = _a.beforeBreadcrumb, beforeBreadcrumb = _b === void 0 ? null : _b, _c = _a.maxBreadcrumbs, maxBreadcrumbs = _c === void 0 ? DEFAULT_BREADCRUMBS : _c;
        if (maxBreadcrumbs <= 0) {
            return;
        }
        var timestamp = new Date().getTime() / 1000;
        var mergedBreadcrumb = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["o" /* consoleSandbox */])(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null) {
            return;
        }
        top.scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setContext = function (name, context) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var top = this.getStackTop();
        if (top.scope && top.client) {
            callback(top.scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client) {
            return null;
        }
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["d" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        var top = this.getStackTop();
        if (top.scope && top.client) {
            var span = top.scope.getSpan();
            if (span) {
                return {
                    'sentry-trace': span.toTraceparent(),
                };
            }
        }
        return {};
    };
    return Hub;
}());

/** Returns the global shim registry. */
function getMainCarrier() {
    var carrier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["a" /* getGlobalObject */])();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* isNodeEnv */])()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Try to read the hub from an active domain, fallback to the registry if one doesnt exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        // We need to use `dynamicRequire` because `require` on it's own will be optimized by webpack.
        // We do not want this to happen, we need to try to `require` the domain node module and fail if we are in browser
        // for example so we do not have to shim it and use `getCurrentHub` universally.
        var domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["q" /* dynamicRequire */])(module, 'domain');
        var activeDomain = domain.active;
        // If there no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or its an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, __WEBPACK_IMPORTED_MODULE_2__scope__["b" /* Scope */].clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return true;
    }
    return false;
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return carrier.__SENTRY__.hub;
    }
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier) {
        return false;
    }
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(112)(module)))

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = captureException;
/* harmony export (immutable) */ __webpack_exports__["d"] = captureMessage;
/* harmony export (immutable) */ __webpack_exports__["c"] = captureEvent;
/* harmony export (immutable) */ __webpack_exports__["e"] = configureScope;
/* harmony export (immutable) */ __webpack_exports__["a"] = addBreadcrumb;
/* harmony export (immutable) */ __webpack_exports__["f"] = setContext;
/* harmony export (immutable) */ __webpack_exports__["h"] = setExtras;
/* harmony export (immutable) */ __webpack_exports__["j"] = setTags;
/* harmony export (immutable) */ __webpack_exports__["g"] = setExtra;
/* harmony export (immutable) */ __webpack_exports__["i"] = setTag;
/* harmony export (immutable) */ __webpack_exports__["k"] = setUser;
/* harmony export (immutable) */ __webpack_exports__["l"] = withScope;
/* unused harmony export _callOnClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(8);


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */])();
    if (hub && hub[method]) {
        // tslint:disable-next-line:no-unsafe-any
        return hub[method].apply(hub, __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
function captureException(exception) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param level Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, level) {
    var syntheticException;
    try {
        throw new Error(message);
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureMessage', message, level, {
        originalException: message,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normailzed.
 */
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normailzed.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 * @param key String key of tag
 * @param value String value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 */
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](['_invokeClient', method], args));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LogLevel */
/** Console logging verbosity for the SDK. */
var LogLevel;
(function (LogLevel) {
    /** No logs will be generated. */
    LogLevel[LogLevel["None"] = 0] = "None";
    /** Only SDK internal errors will be logged. */
    LogLevel[LogLevel["Error"] = 1] = "Error";
    /** Information useful for debugging the SDK will be logged. */
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    /** All SDK actions will be logged. */
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=loglevel.js.map

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Severity; });
/** JSDoc */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case 'error':
                return Severity.Error;
            case 'fatal':
                return Severity.Fatal;
            case 'critical':
                return Severity.Critical;
            case 'log':
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity || (Severity = {}));
//# sourceMappingURL=severity.js.map

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Status; });
/** The status of an event. */
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */
    Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */
    Status["Failed"] = "failed";
})(Status || (Status = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */
    function fromHttpCode(code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})(Status || (Status = {}));
//# sourceMappingURL=status.js.map

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export forget */
/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
function forget(promise) {
    promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        console.error(e);
    });
}
//# sourceMappingURL=async.js.map

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["e"] = fill;
/* harmony export (immutable) */ __webpack_exports__["a"] = urlEncode;
/* harmony export (immutable) */ __webpack_exports__["d"] = normalizeToSize;
/* unused harmony export walk */
/* harmony export (immutable) */ __webpack_exports__["b"] = normalize;
/* harmony export (immutable) */ __webpack_exports__["c"] = extractExceptionKeysForMessage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__memo__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__misc__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__string__ = __webpack_require__(31);




/**
 * Wrap a given object method with a higher-order function
 *
 * @param source An object that contains a method to be wrapped.
 * @param name A name of method to be wrapped.
 * @param replacement A function that should be used to wrap a given method.
 * @returns void
 */
function fill(source, name, replacement) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacement(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    // tslint:disable-next-line:strict-type-predicates
    if (typeof wrapped === 'function') {
        try {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __sentry__: {
                    enumerable: false,
                    value: true,
                },
                __sentry_original__: {
                    enumerable: false,
                    value: original,
                },
                __sentry_wrapped__: {
                    enumerable: false,
                    value: wrapped,
                },
            });
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(
    // tslint:disable-next-line:no-unsafe-any
    function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all it's attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order to be usable by the serializer
 */
function getWalkSource(value) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is__["c" /* isError */])(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack,
        };
        for (var i in error) {
            if (Object.prototype.hasOwnProperty.call(error, i)) {
                err[i] = error[i];
            }
        }
        return err;
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is__["d" /* isEvent */])(value)) {
        var event_1 = value;
        var source = {};
        source.type = event_1.type;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            source.target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is__["e" /* isElement */])(event_1.target)
                ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__misc__["c" /* htmlTreeAsString */])(event_1.target)
                : Object.prototype.toString.call(event_1.target);
        }
        catch (_oO) {
            source.target = '<unknown>';
        }
        try {
            source.currentTarget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is__["e" /* isElement */])(event_1.currentTarget)
                ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__misc__["c" /* htmlTreeAsString */])(event_1.currentTarget)
                : Object.prototype.toString.call(event_1.currentTarget);
        }
        catch (_oO) {
            source.currentTarget = '<unknown>';
        }
        // tslint:disable-next-line:strict-type-predicates
        if (typeof CustomEvent !== 'undefined' && value instanceof CustomEvent) {
            source.detail = event_1.detail;
        }
        for (var i in event_1) {
            if (Object.prototype.hasOwnProperty.call(event_1, i)) {
                source[i] = event_1;
            }
        }
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // tslint:disable-next-line:no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return serialized;
}
/** Transforms any input value into a string form, either primitive value or a type of the input */
function serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === 'string') {
        return value;
    }
    if (type === '[object Object]') {
        return '[Object]';
    }
    if (type === '[object Array]') {
        return '[Array]';
    }
    var normalized = normalizeValue(value);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is__["f" /* isPrimitive */])(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
// tslint:disable-next-line:cyclomatic-complexity
function normalizeValue(value, key) {
    if (key === 'domain' && value && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof global !== 'undefined' && value === global) {
        return '[Global]';
    }
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    // React's SyntheticEvent thingy
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is__["g" /* isSyntheticEvent */])(value)) {
        return '[SyntheticEvent]';
    }
    // tslint:disable-next-line:no-tautology-expression
    if (typeof value === 'number' && value !== value) {
        return '[NaN]';
    }
    if (value === void 0) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + (value.name || '<unknown-function-name>') + "]";
    }
    return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
function walk(key, value, depth, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (memo === void 0) { memo = new __WEBPACK_IMPORTED_MODULE_1__memo__["a" /* Memo */](); }
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) {
        return serializeValue(value);
    }
    // If value implements `toJSON` method, call it and return early
    // tslint:disable:no-unsafe-any
    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
        return value.toJSON();
    }
    // tslint:enable:no-unsafe-any
    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = normalizeValue(value, key);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__is__["f" /* isPrimitive */])(normalized)) {
        return normalized;
    }
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) {
        return '[Circular ~]';
    }
    // Walk all keys of the source
    for (var innerKey in source) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
            continue;
        }
        // Recursively walk through all the child nodes
        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
function normalize(input, depth) {
    try {
        // tslint:disable-next-line:no-unsafe-any
        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    // tslint:disable:strict-type-predicates
    var keys = Object.keys(getWalkSource(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__string__["a" /* truncate */])(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__string__["a" /* truncate */])(serialized, maxLength);
    }
    return '';
}
//# sourceMappingURL=object.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(13)))

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolve */
/* unused harmony export relative */
/* unused harmony export normalizePath */
/* unused harmony export isAbsolute */
/* unused harmony export join */
/* unused harmony export dirname */
/* unused harmony export basename */
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];
        if (last === '.') {
            parts.splice(i, 1);
        }
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        }
        else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        for (; up--; up) {
            parts.unshift('..');
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
/** JSDoc */
function splitPath(filename) {
    var parts = splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */
function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
        if (arr[start] !== '') {
            break;
        }
    }
    var end = arr.length - 1;
    for (; end >= 0; end--) {
        if (arr[end] !== '') {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
    // tslint:disable:no-parameter-reassignment
    from = resolve(from).substr(1);
    to = resolve(to).substr(1);
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = '.';
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += '/';
    }
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */
function isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */
function join() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return normalizePath(args.join('/'));
}
/** JSDoc */
function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return '.';
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
}
/** JSDoc */
function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) {
        f = f.substr(0, f.length - ext.length);
    }
    return f;
}
//# sourceMappingURL=path.js.map

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setPrototypeOf; });
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties); // tslint:disable-line:no-unbound-method
/**
 * setPrototypeOf polyfill using __proto__
 */
function setProtoOf(obj, proto) {
    // @ts-ignore
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        if (!obj.hasOwnProperty(prop)) {
            // @ts-ignore
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromiseBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syncpromise__ = __webpack_require__(32);


/** A simple queue that holds promises. */
var PromiseBuffer = /** @class */ (function () {
    function PromiseBuffer(_limit) {
        this._limit = _limit;
        /** Internal set of queued Promises */
        this._buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */
    PromiseBuffer.prototype.isReady = function () {
        return this._limit === undefined || this.length() < this._limit;
    };
    /**
     * Add a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns The original promise.
     */
    PromiseBuffer.prototype.add = function (task) {
        var _this = this;
        if (!this.isReady()) {
            return __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].reject(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* SentryError */]('Not adding Promise due to buffer limit reached.'));
        }
        if (this._buffer.indexOf(task) === -1) {
            this._buffer.push(task);
        }
        task
            .then(function () { return _this.remove(task); })
            .then(null, function () {
            return _this.remove(task).then(null, function () {
                // We have to add this catch here otherwise we have an unhandledPromiseRejection
                // because it's a new Promise chain.
            });
        });
        return task;
    };
    /**
     * Remove a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    PromiseBuffer.prototype.remove = function (task) {
        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
        return removedTask;
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */
    PromiseBuffer.prototype.length = function () {
        return this._buffer.length;
    };
    /**
     * This will drain the whole queue, returns true if queue is empty or drained.
     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
     *
     * @param timeout Number in ms to wait until it resolves with false.
     */
    PromiseBuffer.prototype.drain = function (timeout) {
        var _this = this;
        return new __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */](function (resolve) {
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            __WEBPACK_IMPORTED_MODULE_1__syncpromise__["a" /* SyncPromise */].all(_this._buffer)
                .then(function () {
                clearTimeout(capturedSetTimeout);
                resolve(true);
            })
                .then(null, function () {
                resolve(true);
            });
        });
    };
    return PromiseBuffer;
}());

//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export supportsErrorEvent */
/* unused harmony export supportsDOMError */
/* unused harmony export supportsDOMException */
/* harmony export (immutable) */ __webpack_exports__["d"] = supportsFetch;
/* harmony export (immutable) */ __webpack_exports__["b"] = supportsNativeFetch;
/* unused harmony export supportsReportingObserver */
/* harmony export (immutable) */ __webpack_exports__["a"] = supportsReferrerPolicy;
/* harmony export (immutable) */ __webpack_exports__["c"] = supportsHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc__ = __webpack_require__(12);


/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        // tslint:disable:no-unused-expression
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // It really needs 1 argument, not 0.
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore
        // tslint:disable:no-unused-expression
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        // tslint:disable:no-unused-expression
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__misc__["a" /* getGlobalObject */])())) {
        return false;
    }
    try {
        // tslint:disable-next-line:no-unused-expression
        new Headers();
        // tslint:disable-next-line:no-unused-expression
        new Request('');
        // tslint:disable-next-line:no-unused-expression
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var isNativeFunc = function (func) { return func.toString().indexOf('native') !== -1; };
    var global = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__misc__["a" /* getGlobalObject */])();
    var result = null;
    var doc = global.document;
    if (doc) {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        try {
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // tslint:disable-next-line no-unbound-method
                result = isNativeFunc(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* logger */].warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    if (result === null) {
        // tslint:disable-next-line no-unbound-method
        result = isNativeFunc(global.fetch);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    // tslint:disable-next-line: no-unsafe-any
    return 'ReportingObserver' in __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__misc__["a" /* getGlobalObject */])();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        // tslint:disable:no-unused-expression
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__misc__["a" /* getGlobalObject */])();
    var chrome = global.chrome;
    // tslint:disable-next-line:no-unsafe-any
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * clipboard.js v2.0.4
 * https://zenorocha.github.io/clipboard.js
 * 
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ClipboardJS"] = factory();
	else
		root["ClipboardJS"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboardAction = __webpack_require__(1);

var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

var _tinyEmitter = __webpack_require__(3);

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

var _goodListener = __webpack_require__(4);

var _goodListener2 = _interopRequireDefault(_goodListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */
var Clipboard = function (_Emitter) {
    _inherits(Clipboard, _Emitter);

    /**
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     * @param {Object} options
     */
    function Clipboard(trigger, options) {
        _classCallCheck(this, Clipboard);

        var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

        _this.resolveOptions(options);
        _this.listenClick(trigger);
        return _this;
    }

    /**
     * Defines if attributes would be resolved using internal setter functions
     * or custom functions that were passed in the constructor.
     * @param {Object} options
     */


    _createClass(Clipboard, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
            this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
            this.text = typeof options.text === 'function' ? options.text : this.defaultText;
            this.container = _typeof(options.container) === 'object' ? options.container : document.body;
        }

        /**
         * Adds a click event listener to the passed trigger.
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         */

    }, {
        key: 'listenClick',
        value: function listenClick(trigger) {
            var _this2 = this;

            this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                return _this2.onClick(e);
            });
        }

        /**
         * Defines a new `ClipboardAction` on each click event.
         * @param {Event} e
         */

    }, {
        key: 'onClick',
        value: function onClick(e) {
            var trigger = e.delegateTarget || e.currentTarget;

            if (this.clipboardAction) {
                this.clipboardAction = null;
            }

            this.clipboardAction = new _clipboardAction2.default({
                action: this.action(trigger),
                target: this.target(trigger),
                text: this.text(trigger),
                container: this.container,
                trigger: trigger,
                emitter: this
            });
        }

        /**
         * Default `action` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultAction',
        value: function defaultAction(trigger) {
            return getAttributeValue('action', trigger);
        }

        /**
         * Default `target` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultTarget',
        value: function defaultTarget(trigger) {
            var selector = getAttributeValue('target', trigger);

            if (selector) {
                return document.querySelector(selector);
            }
        }

        /**
         * Returns the support of the given action, or all actions if no action is
         * given.
         * @param {String} [action]
         */

    }, {
        key: 'defaultText',


        /**
         * Default `text` lookup function.
         * @param {Element} trigger
         */
        value: function defaultText(trigger) {
            return getAttributeValue('text', trigger);
        }

        /**
         * Destroy lifecycle.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            this.listener.destroy();

            if (this.clipboardAction) {
                this.clipboardAction.destroy();
                this.clipboardAction = null;
            }
        }
    }], [{
        key: 'isSupported',
        value: function isSupported() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

            var actions = typeof action === 'string' ? [action] : action;
            var support = !!document.queryCommandSupported;

            actions.forEach(function (action) {
                support = support && !!document.queryCommandSupported(action);
            });

            return support;
        }
    }]);

    return Clipboard;
}(_tinyEmitter2.default);

/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */


function getAttributeValue(suffix, element) {
    var attribute = 'data-clipboard-' + suffix;

    if (!element.hasAttribute(attribute)) {
        return;
    }

    return element.getAttribute(attribute);
}

module.exports = Clipboard;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _select = __webpack_require__(2);

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */
var ClipboardAction = function () {
    /**
     * @param {Object} options
     */
    function ClipboardAction(options) {
        _classCallCheck(this, ClipboardAction);

        this.resolveOptions(options);
        this.initSelection();
    }

    /**
     * Defines base properties passed from constructor.
     * @param {Object} options
     */


    _createClass(ClipboardAction, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = options.action;
            this.container = options.container;
            this.emitter = options.emitter;
            this.target = options.target;
            this.text = options.text;
            this.trigger = options.trigger;

            this.selectedText = '';
        }

        /**
         * Decides which selection strategy is going to be applied based
         * on the existence of `text` and `target` properties.
         */

    }, {
        key: 'initSelection',
        value: function initSelection() {
            if (this.text) {
                this.selectFake();
            } else if (this.target) {
                this.selectTarget();
            }
        }

        /**
         * Creates a fake textarea element, sets its value from `text` property,
         * and makes a selection on it.
         */

    }, {
        key: 'selectFake',
        value: function selectFake() {
            var _this = this;

            var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

            this.removeFake();

            this.fakeHandlerCallback = function () {
                return _this.removeFake();
            };
            this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

            this.fakeElem = document.createElement('textarea');
            // Prevent zooming on iOS
            this.fakeElem.style.fontSize = '12pt';
            // Reset box model
            this.fakeElem.style.border = '0';
            this.fakeElem.style.padding = '0';
            this.fakeElem.style.margin = '0';
            // Move element out of screen horizontally
            this.fakeElem.style.position = 'absolute';
            this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
            // Move element to the same position vertically
            var yPosition = window.pageYOffset || document.documentElement.scrollTop;
            this.fakeElem.style.top = yPosition + 'px';

            this.fakeElem.setAttribute('readonly', '');
            this.fakeElem.value = this.text;

            this.container.appendChild(this.fakeElem);

            this.selectedText = (0, _select2.default)(this.fakeElem);
            this.copyText();
        }

        /**
         * Only removes the fake element after another click event, that way
         * a user can hit `Ctrl+C` to copy because selection still exists.
         */

    }, {
        key: 'removeFake',
        value: function removeFake() {
            if (this.fakeHandler) {
                this.container.removeEventListener('click', this.fakeHandlerCallback);
                this.fakeHandler = null;
                this.fakeHandlerCallback = null;
            }

            if (this.fakeElem) {
                this.container.removeChild(this.fakeElem);
                this.fakeElem = null;
            }
        }

        /**
         * Selects the content from element passed on `target` property.
         */

    }, {
        key: 'selectTarget',
        value: function selectTarget() {
            this.selectedText = (0, _select2.default)(this.target);
            this.copyText();
        }

        /**
         * Executes the copy operation based on the current selection.
         */

    }, {
        key: 'copyText',
        value: function copyText() {
            var succeeded = void 0;

            try {
                succeeded = document.execCommand(this.action);
            } catch (err) {
                succeeded = false;
            }

            this.handleResult(succeeded);
        }

        /**
         * Fires an event based on the copy operation result.
         * @param {Boolean} succeeded
         */

    }, {
        key: 'handleResult',
        value: function handleResult(succeeded) {
            this.emitter.emit(succeeded ? 'success' : 'error', {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
            });
        }

        /**
         * Moves focus away from `target` and back to the trigger, removes current selection.
         */

    }, {
        key: 'clearSelection',
        value: function clearSelection() {
            if (this.trigger) {
                this.trigger.focus();
            }

            window.getSelection().removeAllRanges();
        }

        /**
         * Sets the `action` to be performed which can be either 'copy' or 'cut'.
         * @param {String} action
         */

    }, {
        key: 'destroy',


        /**
         * Destroy lifecycle.
         */
        value: function destroy() {
            this.removeFake();
        }
    }, {
        key: 'action',
        set: function set() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

            this._action = action;

            if (this._action !== 'copy' && this._action !== 'cut') {
                throw new Error('Invalid "action" value, use either "copy" or "cut"');
            }
        }

        /**
         * Gets the `action` property.
         * @return {String}
         */
        ,
        get: function get() {
            return this._action;
        }

        /**
         * Sets the `target` property using an element
         * that will be have its content copied.
         * @param {Element} target
         */

    }, {
        key: 'target',
        set: function set(target) {
            if (target !== undefined) {
                if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                    if (this.action === 'copy' && target.hasAttribute('disabled')) {
                        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    }

                    if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                    }

                    this._target = target;
                } else {
                    throw new Error('Invalid "target" value, use a valid Element');
                }
            }
        }

        /**
         * Gets the `target` property.
         * @return {String|HTMLElement}
         */
        ,
        get: function get() {
            return this._target;
        }
    }]);

    return ClipboardAction;
}();

module.exports = ClipboardAction;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    };

    listener._ = callback
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(5);
var delegate = __webpack_require__(6);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(7);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ })
/******/ ]);
});

/***/ }),
/* 109 */,
/* 110 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * universal-ga v1.2.0
 * https://github.com/daxko/universal-ga 
 *
 * Copyright (c) 2017 Daxko
 * MIT License
 */

(function(global) {
  'use strict';

  function warn(s) {
    console.warn('[analytics]', s);
  }

  function _set() {
    var args = []
      , length = arguments.length
      , i = 0;

    for(; i < length; i++) {
      args.push(arguments[i]);
    }

    while(typeof args[args.length - 1] === 'undefined') {
      args.pop();
    }

    /* jshint validthis: true */
    if(this._namespace) {
      args[0] = this._namespace + '.' + args[0];
      this._namespace = null;
    }

    if(window && typeof window.ga === 'function') {
      window.ga.apply(undefined, args);
    }
  }

  var Analytics = function() {
    return this;
  };

  Analytics.prototype = {

    initialize: function(trackingID, options) {
      var src = 'https://www.google-analytics.com/';

      if(typeof trackingID === 'object') {
        options = trackingID;
      }

      options = options || {};

      if(options.debug) {
        src += 'analytics_debug.js';
        delete options.debug;
      } else {
        src += 'analytics.js';
      }

      /* jshint ignore:start */
      (function(i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;
        i[r] = i[r] || function() {
          (i[r].q=i[r].q||[]).push(arguments)
        }, i[r].l = 1 * new Date();
        a = s.createElement(o),
        m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m)
      })(window, document, 'script', src, 'ga');
      /* jshint ignore:end */

      if(trackingID) {
        options = JSON.stringify(options) === "{}" ? undefined : options;
        this.create(trackingID, options);
      }
    },

    create: function(trackingID, options) {
      if(!trackingID) {
        warn('tracking id is required to initialize.');
        return;
      }

      _set.call(this, 'create', trackingID, 'auto', options);
    },

    name: function(name) {
      var self = new Analytics();
      self._namespace = name;
      return self;
    },

    set: function(key, value) {
      if(!key || !key.length) {
        warn('set: `key` is required.');
        return;
      }

      _set.call(this, 'set', key, value);

      return this;
    },

    plugin: function(name, options) {
      if(!name || !name.length) {
        warn('plugin: `name` is required.');
        return;
      }

      _set.call(this, 'require', name, options);

      return this;
    },

    // https://developers.google.com/analytics/devguides/collection/analyticsjs/pages
    pageview: function(path, options) {
      _set.call(this, 'send', 'pageview', path, options);

      return this;
    },

    // https://developers.google.com/analytics/devguides/collection/analyticsjs/screens
    screenview: function(screenName, options) {
      if(!screenName) {
        warn('screenview: `screenName` is required.');
        return;
      }

      options = options || {};
      options.screenName = screenName;
      _set.call(this, 'send', 'screenview', options);

      return this;
    },

    // https://developers.google.com/analytics/devguides/collection/analyticsjs/events
    event: function(category, action, options) {
      if(!category || !action) {
        warn('event: both `category` and `action` are required.');
        return;
      }

      if(options && typeof options.eventValue !== 'undefined' && typeof options.eventValue !== 'number') {
        warn('event: expected `options.eventValue` to be a Number.');
        options.eventValue = undefined;
      }

      if(options && options.nonInteraction && typeof options.nonInteraction !== 'boolean') {
        warn('event: expected `options.nonInteraction` to be a boolean.');
        options.nonInteraction = false;
      }

      _set.call(this, 'send', 'event', category, action, options);

      return this;
    },

    // https://developers.google.com/analytics/devguides/collection/analyticsjs/user-timings
    timing: function(timingCategory, timingVar, timingValue, options) {
      if(!timingCategory || !timingVar || typeof timingValue === 'undefined') {
        warn('timing: `timingCategory`, `timingVar`, and `timingValue` are required.');
      } else if (typeof timingValue !== 'number') {
        warn('event: expected `timingValue` to be a Number.');
      } else {
        _set.call(this, 'send', 'timing', timingCategory, timingVar, timingValue, options);
      }

      return this;
    },

    // https://developers.google.com/analytics/devguides/collection/analyticsjs/exceptions
    exception: function(message, isFatal) {
      _set.call(this, 'send', 'exception', {
        exDescription: message,
        exFatal: !!isFatal
      });

      return this;
    },

    // https://developers.google.com/analytics/devguides/collection/analyticsjs/custom-dims-mets
    custom: function(key, value) {
      if(!/(dimension|metric)[0-9]+/i.test(key)) {
        warn('custom: key must match dimension[0-9]+ or metric[0-9]+');
        return;
      }

      _set.call(this, 'set', key, value);

      return this;
    },

    // https://developers.google.com/analytics/devguides/collection/analyticsjs/ecommerce

    initializeEcommerce: function() {
      this.plugin('ecommerce');
    },
    ecAddTransaction: function(transaction) {
      if(!transaction || !transaction.id){
        warn('addTransaction: `transaction` is required and needs an `id`.');
        return;
      }

      _set.call(this, 'ecommerce:addTransaction', transaction);

      return this;
    },
    ecAddItem: function(productItem) {
      if(!productItem || !productItem.id || !productItem.name){
        warn('addItem: `productItem` is required and needs an `id` and a `name`.');
        return;
      }

      _set.call(this, 'ecommerce:addItem', productItem);

      return this;
    },
    ecSend: function() {
      _set.call(this, 'ecommerce:send');
    },
    ecClear: function () {
      _set.call(this, 'ecommerce:clear');
    }

  };

  var ua = new Analytics();
  /* istanbul ignore next */
  if(true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() { return ua; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = ua;
  } else {
    global.analytics = ua;
  }

})(this);

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

/* Fetch content of Creek /page */

const events = __webpack_require__(0);
const fetch = __webpack_require__(7);

const pages = {
  fetch: function fetchPage(path) {
    fetch.get(path, { headers: { 'x-bff-content-update': '1' } }, {
      success: function (domResponse) {
        document.dispatchEvent(new CustomEvent(events.dataHtmlPage, {
          detail: domResponse
        }));
      },
      failure: function currentTrackFailed(e) {
        console.warn(e);
      }
    });
  }
};

module.exports = pages;


/***/ }),
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports) {

function EventTiming() {
  this.times = [];

  Object.defineProperty(this, 'total', {
    get: function getTotalTime() {
      const total = this.times.map(function (event) {
        return event[1] - event[0];
      }).reduce(function (a, b) { return a + b; }, 0);
      return total > 0 ? total / 1000 : 0;
    }
  });
}

EventTiming.prototype.start = function startEvent() {
  const now = Date.now();
  this.times.push([now, now]);
};

EventTiming.prototype.extend = function extendEvent() {
  const now = Date.now();
  const currentEvent = this.times.pop();
  this.times.push([currentEvent[0], now]);
};

module.exports = EventTiming;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

const A_MINUTE = 60;
const AN_HOUR = 60 * 60;

function pad(number, magnitude) {
  const stringNum = ('' + Math.abs(number)).split('').reverse();

  return Array.apply(null, Array(magnitude)).map(function (p, index) {
    return stringNum[index] || '0';
  }).concat(number < 0 ? '-' : '')
    .reverse()
    .join('');
}

function formatTime(time) {
  time = Math.floor(time);

  const hours = Math.floor(time / AN_HOUR);
  const remainingSeconds = time % (AN_HOUR);

  const minutes = Math.floor(remainingSeconds / A_MINUTE);
  const seconds = remainingSeconds % A_MINUTE;

  return (hours > 0 ? [hours, pad(minutes, 2), pad(seconds, 2)] : [minutes, pad(seconds, 2)]).join(':');
}

module.exports = {
  pad: pad,
  formatTime: formatTime
};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var compatibility = __webpack_require__(10);
var authCheck = __webpack_require__(44);

var events = __webpack_require__(0);
var domReady = __webpack_require__(5);

var Analytics = __webpack_require__(36);
var Sentry = __webpack_require__(43);
var Development = __webpack_require__(39);

var Navigation = __webpack_require__(42);

var NotificationsTicker = __webpack_require__(63);
var Modal = __webpack_require__(61);
var ClampedContent = __webpack_require__(51);

var DynamicDocument = __webpack_require__(54);
var BffMenuBar = __webpack_require__(50);
var FixedGlobalNav = __webpack_require__(55);
var Hamburger = __webpack_require__(56);
var Totaliser = __webpack_require__(77);

var SiteSearch = __webpack_require__(71);

var MiniSchedule = __webpack_require__(60);
var SlideDeck = __webpack_require__(72);

var ScheduleNavigation = __webpack_require__(68);
var ShowsGrid = __webpack_require__(70);

var Twitter = __webpack_require__(78);
var SharePopup = __webpack_require__(69);
var DonationPrompt = __webpack_require__(53);
var DonationConfirmation = __webpack_require__(52);
var InvokeDonation = __webpack_require__(57);
var KindfulDonation = __webpack_require__(58);
var KindfulLinkHandler = __webpack_require__(59);

// TODO: PodcastInfo, AddReminder, AddFeed could be merged
var PodcastInfo = __webpack_require__(66);
var AddReminder = __webpack_require__(47);
var AddFeed = __webpack_require__(46);
var SubscribeDialog = __webpack_require__(74);

var Themeable = __webpack_require__(76);
var ThemeToggle = __webpack_require__(75);

var fontHelper = __webpack_require__(45);

// Analytics & Error Logging
var analytics = new Analytics();
new Sentry();

// Helpers if we're in dev mode
new Development();

// Init Components
function initGlobalComponents() {
  const html = document.body.parentElement;
  const body = document.body;
  const navManager = new Navigation(document.body);
  navManager.contentSelector = '.DynamicDocument-content';

  // Lazy-load Flama to prevent FOIT
  fontHelper.loadFonts();

  DynamicDocument.discover(html);
  FixedGlobalNav.discover(html);
  Themeable.discover(html);
  ThemeToggle.discover(body);

  Hamburger.discover(body);
  BffMenuBar.discover(body);
  NotificationsTicker.discover(body);
  SiteSearch.discover(body);
  DonationPrompt.discover(body);
  DonationConfirmation.discover(body);
  KindfulDonation.discover(body);
  KindfulLinkHandler.discover(body);
  Totaliser.discover(body);
}

function initContentComponents() {
  var body = document.body;

  MiniSchedule.discover(body);
  SlideDeck.discover(body);
  ShowsGrid.discover(body);
  ScheduleNavigation.discover(body);
  Modal.discover(body);
  ClampedContent.discover(body);

  Twitter.discover(body);
  InvokeDonation.discover(body);
  SharePopup.discover(body);

  PodcastInfo.discover(body);
  SubscribeDialog.discover(body);
  AddReminder.discover(body);
  AddFeed.discover(body);
}

// TODO: Maybe properly componentise this.
authCheck();

// Don't initialize app if browsing is missing features
if (compatibility()) {
  // TODO: Add “discover” to UI components.
  domReady(function () {
    initGlobalComponents();
    initContentComponents();
  });

  document.addEventListener(events.navigationRequestEnded, function (e) {
    if (e.detail.didNavigate) {
      initContentComponents();
    }
  });
} else {
  analytics.legacyBrowserImpression();
  document.body.className += ' u-noJs';
}


/***/ }),
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

const forgeUiComponent = __webpack_require__(1);

const BffLogo = forgeUiComponent('BFFLogo', {
  minimized: 'is-minimized'
});

module.exports = BffLogo;


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

const forgeUiComponent = __webpack_require__(1);
const timeFormatter = __webpack_require__(123);

const ON_AIR_TEXT = 'On Air';

var NotificationsGroup = forgeUiComponent('NotificationsTicker-group', {
  enabled: 'is-enabled'
}, function NotificationsGroupConstructor(el, options) {
  var self = this;
  var trackTitle = el.querySelector('.TrackInfo-title') || document.createElement('div');
  var trackSubtitle = el.querySelector('.TrackInfo-subTitle') || document.createElement('div');
  var sourceTitle = el.querySelector('.SourceInfo-title') || document.createElement('a');
  var sourceCaption = el.querySelector('.SourceInfo-caption') || document.createElement('div');
  var sourceImage = el.querySelector('.SourceInfo-artImage') || document.createElement('div');

// Expose properties
  Object.defineProperty(this, 'artSrc', {
    get: function getArt() { return sourceImage.src; },
    set: function setArt(src) {
      // HACK: FIX: This code doesn't support <picture>/srcset yet, so we're hard-coding to 2x retina as a compromise.
      const ioSrc = [src, '?', 'width=360&height=360&fit=crop'].join('');

      if (sourceImage.src === ioSrc) { return; }

      sourceImage.src = src ? ioSrc : '';
      this.missingImage = !src;
    }
  });

  Object.defineProperty(this, 'title', {
    get: function getTitle() { return trackTitle.textContent; },
    set: function setTitle(title) {
      if (trackTitle.textContent === title) { return; }

      requestAnimationFrame(function () {
        trackTitle.textContent = title || '';
        trackTitle.title = title || '';
      });
    }
  });

  Object.defineProperty(this, 'subTitle', {
    get: function getSubTitle() { return trackSubtitle.textContent; },
    set: function setSubTitle(subTitle) {
      if (trackSubtitle.textContent === subTitle) { return; }

      requestAnimationFrame(function () {
        trackSubtitle.textContent = subTitle || '';
        trackSubtitle.title = subTitle || '';
      });
    }
  });

  Object.defineProperty(this, 'showName', {
    get: function getShowName() { return sourceTitle.textContent; },
    set: function setShowName(showName) {
      if (sourceTitle.textContent === showName) { return; }

      requestAnimationFrame(function () {
        sourceTitle.textContent = showName || '';
        sourceTitle.title = showName || '';
      });
    }
  });

  Object.defineProperty(this, 'showUrl', {
    get: function getShowName() { return sourceTitle.href; },
    set: function setShowName(url) {
      if (sourceTitle.href === url) { return; }
      sourceTitle.href = url || '';
    }
  });

  Object.defineProperty(this, 'showCaption', {
    get: function getShowCaption() { return sourceCaption.textContent; },
    set: function setShowCaption(caption) {
      const newCaption = this.liveStream ? ON_AIR_TEXT : caption || '';

      if (sourceCaption.textContent === newCaption) { return; }

      requestAnimationFrame(function () {
        sourceCaption.textContent = newCaption;
      });
    }
  });

  options.bindRecieveMetadataUpdate(function (metadata) {
    self.updateContent(metadata);
  });
  options.bindRecieveProgressUpdate(function (progress) {
    self.updateProgress(progress);
  });
});

NotificationsGroup.prototype.updateContent = function updateContent(metadata) {
  this.enabled = !!metadata.title;

  if (!metadata.title) { return; }

  this.title = metadata.title;
  this.subTitle = metadata.artist;

  this.showName = metadata.show;
  this.showUrl = metadata.showUrl;

  // HACK: We're duplicating setting the text for ON AIR due to being out of sync
  // updating the real element content. Might need some sort of buffer for that.
  this.showCaption = metadata.isStream ? ON_AIR_TEXT : metadata.duration;

  this.artSrc = metadata.image;
  this.liveStream = metadata.isStream;
};

NotificationsGroup.prototype.updateProgress = function updateProgress(metadata) {
  this.showCaption = (metadata.duration && (metadata.duration !== Infinity)) ?
    [timeFormatter.formatTime(metadata.time), timeFormatter.formatTime(metadata.duration)].join('/') :
    timeFormatter.formatTime(metadata.time);
};

module.exports = NotificationsGroup;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bff.bundle.js